/**
 * @file
 * Language: Portuguese Brazil
 */
export default {
  app: {
    title: 'iTrack Admin',
    subtitle: 'Painel Admin',
    logout: 'Sair',
    menu: 'Menu',
    add: 'Cadastrar',
    addNew: 'Adicionar',
    apply: 'Aplicar',
    export: 'Exportar',
    select: 'Selecione',
    remove: 'Remover',
    confirm: 'Confirmar',
    importXlsx: 'Importar xlsx',
    importCsv: 'Importar CSV',
    cancel: 'Cancelar',
    noDataToShow: 'Nenhum dado para apresentar',
    downloadCsv: 'Baixar CSV',
    downloadXlsx: 'Baixar XLSX',
    downloadExample: 'Baixar exemplo',
    all: 'Todos',
    filters: 'Filtros',
    search: 'Buscar',
    submit: 'Enviar',
    totalLines: '{total} entradas no total',
    version: 'Versão',
    clickToCopy: 'Clique para copiar',
    removeByCsv: 'Remover por CSV',
    onlyIfWantChangePassword:
      'Preencha este campo somente se quiser alterar a senha',
    approve: 'Aprovar',
    disapprove: 'Reprovar',
    save: 'Salvar',
    generateReport: 'Gerar relatório',
    generating: 'Gerando...',
    exportReport: 'Exportar Relatório',
    chooseFileImage: 'Escolher Imagem',
    removeFileImage: 'Remover Imagem',
    allowedFileTypes: 'Tipos de arquivo',
    dropFilesImageOr:
      'Arraste o arquivo de imagem nessa área ou se preferir clique no botão abaixo',
    noImage: 'Sem imagem',
    exceedMaxNumberOfImages:
      'Você selecionou uma quantidade maior do que o limite de imagens',
    fileTypeNotAllowed: 'Tipo de arquivo não suportado',
    unexpectedFileError:
      'Ocorreu um erro inexperado ao enviar o arquivo, tente novamente mais tarde',
    ok: 'OK',
    errorCsvReadLine: 'Erro ao ler a linha {linha}',
    errorCsvReadFile: 'Erro ao ler o arquivo',
    csvInsertTotal: 'Foram inseridos {total} item(s)',
    errorCsvReadLineComplete: 'Erro ao ler a linha {linha}: {error}',
    uploadByCsv: 'Upload CSV',
  },

  system: {
    question: {
      confirmRemove: 'Tem certeza que deseja remover este item?',
    },
    info: {
      welcome: 'Bem-vindo',
      copiedToClipboard: 'Copiado para a área de transferência',
      cargaRemoved: '{successQty} carga(s) removidas',
      cargaIgnored: '{ignoredQty} carga(s) ignoradas',
      cargaReprocessed: '{reprocessedLength} carga(s) reprocessadas',
      cargaToBeReprocessed: 'Carga linha {linha} está sendo reprocessada',
    },
    success: {
      recoverPasswordByMail: 'Um e-mail foi enviado à sua conta',
      resetPassword: 'Senha alterada com sucesso',
      changePassword: 'Senha alterada com sucesso',
      persist: 'Salvo com Sucesso!',
    },
    error: {
      unauthorized: 'Acesso Restrito',
      wrongFormat: 'Formato Inválido',
      noServer: 'Não foi possível conectar ao servidor',
      passwordConfirmationFails: 'A confirmação de senha não bate com a senha',
      passwordIsNotValid: 'Senha não pode ser vazio',
      responsavelNulo: 'Responsável não pode ser vazio',
      invalidDataInicial: 'Data Inicial vazia ou inválida',
      invalidDataFinal: 'Data Final vazia ou inválida',
      invalidDataVencimento: 'Data de vencimento inválida',
      emptyDataVencimento: 'Data de Vencimento não pode ser vazio',
      invalidCpfCnpj: 'CPF/CNPJ inválido',
      fieldIsNotValid: '{field} não pode ser vazio',
      cargaNotReprocessed: 'Erro ao reprocessar carga na linha {linha}',
    },
    format: {
      inputDate: 'YYYY-MM-DD',
    },
  },

  view: {
    signIn: {
      title: 'Fazer Login',
      signin: 'Entrar',
      forgotPassword: 'Esqueci senha',
    },
    dashboard: {
      title: 'Dashboard {mode}',
      dashboard: 'Dashboard',
      annually: 'Anual',
      monthly: 'Mensal/Anual',
    },
    notasInseridas: {
      monthly: {
        title: 'Acompanhamento Notas Inseridas - Mensal',
      },
      weelky: {
        title: 'Acompanhamento Notas Inseridas - Semanal',
      },
      nomeFantasia: 'Nome Fantasia',
      lastUpdate: 'Data última modificação',
    },
    inputResponsavelGrupoParceiro: {
      companyLogo: 'Logo da Empresa',
      noCompanyLogo: 'Sem imagem',
      cnpjMaster: 'CNPJ do Responsável pelo Grupo',
      addNew: 'Adicionar',
      save: 'Salvar',
      cancel: 'Cancelar',
      titleList: 'Parceiros Permitidos:',
      cnpjParceiroPermitido: 'CNPJ do Resp. Permitido',
    },
    inputResponsavelGrupoEconomico: {
      companyLogo: 'Logo da Empresa',
      noCompanyLogo: 'Sem imagem',
      cnpjMaster: 'CNPJ do Responsável Mestre',
      newPassword: 'Definir nova Senha Master',
      visaoTransportador: 'Visão Transportador',
      visaoEmbarcador: 'Visão Embarcador',
      confirmPassword: 'Confirmar Senha Master',
      submitPassword: 'Definir Senha Master',
      submitVisao: 'Salvar Visão',
      addNew: 'Adicionar',
      save: 'Salvar',
      cancel: 'Cancelar',
      titleList: 'Responsáveis Permitidos:',
      cnpjResponsavelPermitido: 'CNPJ do Resp. Permitido',
      error: {
        passwordNotConfirmed: 'A confirmação de Senha Master não bate',
        invalidPassword: 'A Senha Master deve ter pelo menos 6 dígitos!',
        emptyPassword: 'O campo de Senha Master não pode estar vazio',
        hasNoGroup: 'Deve ter ao menos uma visão ativa',
      },
    },
    persistMotorista: {
      workingDay: 'Jornada',
      error: {
        noWorkingDaySelected:
          'Selecione ao menos um dia da semana para a jornada',
        nomeEmpty: 'Nome não pode ser vazio',
        cpfEmpty: 'CPF não pode ser vazio',
        rgEmpty: 'RG não pode ser vazio',
        celularEmpty: 'Celular não pode ser vazio',
        placaVeiculoEmpty: 'Placa Veículo não pode ser vazio',
        placaVeiculoInvalid: 'Placa Veículo não pode ter menos de 7 caracteres',
        placaCarroceiraInvalid:
          'Placa da Carroceria não pode ter menos de 7 caracteres',
        dataNascimentoEmty: 'Data de Nascimento não pode ser vazio',
        tipoVeiculoEmpty: 'Tipo de Veículo não pode ser vazio',
        marcaVeiculoEmpty: 'Marca do Veículo não pode ser vazio',
        horaInicioEmpty: 'Hora Início não pode ser vazio',
        horaFimEmpty: 'Hora Fim não pode ser vazio',
        cepInicioEmpty: 'CEP Início não pode ser vazio',
        cepFimEmpty: 'CEP Fim não pode ser vazio',
      },
    },
    persistTipoPessoaRecebedor: {
      error: {
        nomeEmpty: 'Nome não pode ser vazio',
      },
    },
    persistAlerta: {
      error: {
        descricaoEmpty: 'Descrição não pode ser vazio',
      },
    },
    persistVisualizationModeView: {
      addNew: 'Adicionar',
    },
    persistFaturamentoConfiguracaoView: {
      titleList: 'Faixa',
      addNew: 'Adicionar mais',
    },
  },

  modal: {
    approveWhatsapp: {
      title: 'Informe o ID Template para realizar a aprovação',
    },
    disapproveWhatsapp: {
      title: 'Tem certeza que deseja reprovar este item?',
    },
    exportReport: {
      title: 'Exportar Relatório',
      subtitle: 'Por favor, digite o data inicial e data final',
    },
    updateExpiringDate: {
      title: 'Alterar Data de Vencimento',
      subtitle: 'Por favor, digite a data de vencimento',
    },
    updateActive: {
      title: 'Bloquear Acesso',
      subtitle: 'Tem certeza que deseja bloquear o acesso deste responsável?',
    },
  },

  resource: {
    AlertaCarga: 'Alerta Carga',
    Promocao: 'Promocao',
    ResponsavelWebhook: 'Responsavel Webhook',
    ConfigAlerta: 'Config Alerta',
    CargaMedlog: 'Carga Medlog',
    WebserviceIntegracao: 'Webservice Integracao',
    TypeWebhook: 'Type Webhook',
    StatusCarga: 'Status Carga',
    ResponsavelVisualizador: 'Responsavel Visualizador',
    CargaPesquisaSatisfacao: 'Carga Pesquisa Satisfacao',
    AuditoriaTransfolha: 'Auditoria Transfolha',
    CargaSaraiva: 'Carga Saraiva',
    TipoRelatorio: 'Tipo Relatorio',
    Administrador: 'Administrador',
    OcorrenciaTracking: 'Ocorrencia Tracking',
    ResponsavelAssociado: 'Responsavel Associado',
    TipoPessoaRecebedor: 'Tipo de Pessoa Recebedor',
    EditTipoPessoaRecebedor: 'Novo/Editar Tipo de Pessoa Recebedor',
    RequestSsw: 'Request Ssw',
    ResponsavelConfigSms: 'Responsavel Config Sms',
    ResponsavelConfigWhatsapp: 'Config Whatsapp',
    CargaAryzta: 'Carga Aryzta',
    TokenPush: 'Token Push',
    CargaCorreios: 'Carga Correios',
    CargaFoto: 'Carga Foto',
    AuditoriaObservacao: 'Auditoria Observacao',
    Carga: {
      title: 'Carga',
      national: {
        title: 'Carga Brasil',
      },
      international: {
        title: 'Carga Exterior',
      },
      region: {
        national: 'Brasil',
        international: 'Exterior',
      },
    },
    CargaTransfolha: 'Carga Transfolha',
    Sistema: 'Sistema',
    EmailDestinatario: 'Email Destinatario',
    Faturamento: 'Faturamento',
    FaturamentoRelatorio: 'Relatório',
    FaturamentoConfiguracao: 'Configuração',
    ResponseRoboCnpj: 'Response Robo Cnpj',
    CargaKarcher: 'Carga Karcher',
    CargaDestinatario: 'Carga Destinatario',
    MotoristaTransbordo: 'Motorista Transbordo',
    Banner: 'Banner',
    CargaResponsavel: 'Carga Responsavel',
    ResponsavelHistoricoSms: 'Responsavel Historico Sms',
    Motorista: 'Entregador',
    EditMotorista: 'Novo/Editar Entregador',
    CargaTemp: 'Carga Temp',
    AdminConfig: {
      title: 'Configurações Gerais',
      national: {
        title: 'Brasil',
      },
      international: {
        title: 'Exterior',
      },
      settings: 'Configuração',
      auditReasons: 'Motivos para Auditoria',
      alertTypes: 'Tipo de Alerta',
      receiverType: 'Tipo de Pessoa Recebedor',
    },
    RotaSla: 'Rota Sla',
    FormatoArquivoRelatorio: 'Formato Arquivo Relatorio',
    MotoristaCancelamentoCarga: 'Motorista Cancelamento Carga',
    Auditoria: 'Auditoria',
    OcorrenciaTrackingResponsavel: {
      title: 'Tracking',
      errors: {
        invalidIdOcorrenciaExterna: 'ID Externo inválido',
        invalidDescricao: 'Descrição inválida',
        invalidCnpj: 'CNPJ inválido',
        invalidAtivo: 'Ativo inválido',
      },
    },
    NewOrEditTipoVeiculo: 'Cadastrar/Editar Veiculo',
    NewOrEditOcorrenciaTrackingResponsavel: 'Cadastrar/Editar Tracking',
    EsconderMotorista: 'Esconder Motorista',
    RelatorioGeracao: 'Relatorio Geracao',
    CompartilhamentoApp: 'Compartilhamento App',
    Responsavel: {
      title: 'Responsável',
      list: 'Listagem',
      edit: 'Novo/Editar Responsável',
      national: {
        title: 'Responsável Brasil',
      },
      international: {
        title: 'Responsável Exterior',
      },
      region: {
        national: 'Brasil',
        international: 'Exterior',
      },
      visualizationMode: 'Grupo Visualizador',
      editVisualizationMode: 'Novo/editar Grupo visualizador',
    },
    ErroIntegracao: 'Erro de Integracão',
    RelatorioEntregas: 'Relatório Entregas',
    Alerta: 'Tipo de Alerta',
    EditAlerta: 'Novo/Editar Tipo de Alerta',
    Rastreamento: 'Rastreamento',
    MotoristaResponsavel: 'Motorista Responsavel',
    BaseFretebasEmpresa: 'Base Fretebas Empresa',
    ResponsavelGrupoEconomico: 'Responsável Grupo Econômico',
    ResponsavelGrupoParceiro: 'Responsável Grupo Parceiro',
    RastreamentoHistorico: 'Rastreamento Historico',
    TypeSms: 'Type Sms',
    AuditoriaMotivo: 'Motivos para Auditoria',
    EditAuditoriaMotivo: 'Novo/Editar Motivo para Auditoria',
    PosicaoMotorista: 'Posicao Motorista',
    CentroDeCusto: 'Centro De Custo',
    MotoristaMensagemPush: 'Motorista Mensagem Push',
    MascaraTransportadorSacPublico: 'Mascara Transportador Sac Publico',
    TipoOcorrencia: 'Tipo de Ocorrência',
    TipoVeiculo: 'Tipo de Veiculo',
    CadastrarTracking: 'Cadastrar Tracking',
    CadastrarTipoVeiculo: 'Cadastrar Tipo Veículo',
    EditTipoOcorrencia: 'Novo/Editar Tipo de Ocorrência',
    ResponseRobo: 'Response Robo',
    PontaSla: 'Ponta Sla',
    ReponsavelAssociado: 'Reponsavel Associado',
    ResponsavelFilial: 'Responsavel Filial',
    ResponsavelSaraiva: 'Responsavel Saraiva',
    ParametroRelatorio: 'Parametro Relatorio',
    StatusSms: 'Status Sms',
    BaseFretebas: 'Base Fretebas',
    SaraivaCnpjDisponivel: 'Saraiva Cnpj Disponivel',
    Endereco: 'Endereco',
    CargaOpenlog: 'Carga Openlog',
    Dashboard: 'Dashboard',
    RelatorioAutomatico: 'Relatório Automático',
    AcompanhamentoNotasInseridas: {
      title: 'Acompanhamento de Notas Inseridas',
      monthly: 'Mensal',
      weekly: 'Semanal',
      settings: 'Configuração',
    },
    Webhook: {
      title: 'Webhook',
      reprocessCargaWebhook: 'REPROCESSAR CARGAS WEBHOOK',
    },
    ResponsavelUsuario: {
      title: 'Cadastro de Usuário',
      new: 'Novo Usuário',
      edit: 'Editar Usuário',
    },
  },

  schema: {
    InputAuthRequest: {
      email: 'Email',
      senha: 'Senha',
    },
    InputRecoverPasswordByMailRequest: {
      email: 'Email',
    },
    InputResetPasswordRequest: {
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      hash: 'Hash',
    },
    InputChangePasswordRequest: {
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
    },
    ListAuthResponse: {
      token: 'Token',
      administrador: 'Administrador',
    },
    CsvAuthResponse: {
      token: 'Token',
      administrador: 'Administrador',
    },
    InputAlertaCarga: {
      idAlertaCargaPk: 'Id Alerta Carga Pk',
      alerta: 'Alerta',
      carga: 'Carga',
      motorista: 'Motorista',
      dataAlerta: 'Data Alerta',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
      idAlertaFk: 'Id Alerta Fk',
    },
    ListAlertaCarga: {
      idAlertaCargaPk: 'Id Alerta Carga Pk',
      alerta: 'Alerta',
      carga: 'Carga',
      motorista: 'Motorista',
      dataAlerta: 'Data Alerta',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
      idAlertaFk: 'Id Alerta Fk',
    },
    CsvAlertaCarga: {
      idAlertaCargaPk: 'Id Alerta Carga Pk',
      alerta: 'Alerta',
      carga: 'Carga',
      motorista: 'Motorista',
      dataAlerta: 'Data Alerta',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
      idAlertaFk: 'Id Alerta Fk',
    },
    InputPromocao: {
      idPromocaoPk: 'Id Promocao Pk',
      nome: 'Nome',
      urlImagem: 'Url Imagem',
      urlRedirect: 'Url Redirect',
      dataInicio: 'Data Inicio',
      dataFim: 'Data Fim',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
    },
    ListPromocao: {
      idPromocaoPk: 'Id Promocao Pk',
      nome: 'Nome',
      urlImagem: 'Url Imagem',
      urlRedirect: 'Url Redirect',
      dataInicio: 'Data Inicio',
      dataFim: 'Data Fim',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
    },
    CsvPromocao: {
      idPromocaoPk: 'Id Promocao Pk',
      nome: 'Nome',
      urlImagem: 'Url Imagem',
      urlRedirect: 'Url Redirect',
      dataInicio: 'Data Inicio',
      dataFim: 'Data Fim',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
    },
    InputResponsavelWebhook: {
      idWebhookPk: 'Id Webhook Pk',
      responsavel: 'Responsavel',
      typeWebhook: 'Type Webhook',
      url: 'Url',
      idResponsavelFk: 'Id Responsavel Fk',
      idTypeFk: 'Id Type Fk',
    },
    ListResponsavelWebhook: {
      idWebhookPk: 'Id Webhook Pk',
      responsavel: 'Responsavel',
      typeWebhook: 'Type Webhook',
      url: 'Url',
      idResponsavelFk: 'Id Responsavel Fk',
      idTypeFk: 'Id Type Fk',
    },
    CsvResponsavelWebhook: {
      idWebhookPk: 'Id Webhook Pk',
      responsavel: 'Responsavel',
      typeWebhook: 'Type Webhook',
      url: 'Url',
      idResponsavelFk: 'Id Responsavel Fk',
      idTypeFk: 'Id Type Fk',
    },
    InputConfigAlerta: {
      idConfigAlertaPk: 'Id Config Alerta Pk',
      responsavel: 'Responsavel',
      ativo: 'Ativo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListConfigAlerta: {
      idConfigAlertaPk: 'Id Config Alerta Pk',
      responsavel: 'Responsavel',
      ativo: 'Ativo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvConfigAlerta: {
      idConfigAlertaPk: 'Id Config Alerta Pk',
      responsavel: 'Responsavel',
      ativo: 'Ativo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputCargaMedlog: {
      idCargaMedlogPk: 'Id Carga Medlog Pk',
      carga: 'Carga',
      erro: 'Erro',
      idCargaFk: 'Id Carga Fk',
    },
    ListCargaMedlog: {
      idCargaMedlogPk: 'Id Carga Medlog Pk',
      carga: 'Carga',
      erro: 'Erro',
      idCargaFk: 'Id Carga Fk',
    },
    CsvCargaMedlog: {
      idCargaMedlogPk: 'Id Carga Medlog Pk',
      carga: 'Carga',
      erro: 'Erro',
      idCargaFk: 'Id Carga Fk',
    },
    InputWebserviceIntegracao: {
      idWebserviceFk: 'Id Webservice Fk',
      path: 'Path',
    },
    ListWebserviceIntegracao: {
      idWebserviceFk: 'Id Webservice Fk',
      path: 'Path',
    },
    CsvWebserviceIntegracao: {
      idWebserviceFk: 'Id Webservice Fk',
      path: 'Path',
    },
    InputTypeWebhook: {
      idTypePk: 'Id Type Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    ListTypeWebhook: {
      idTypePk: 'Id Type Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    CsvTypeWebhook: {
      idTypePk: 'Id Type Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    InputStatusCarga: {
      idStatusPk: 'Id Status Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    ListStatusCarga: {
      idStatusPk: 'Id Status Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    CsvStatusCarga: {
      idStatusPk: 'Id Status Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    InputResponsavelVisualizador: {
      idVisualizadorPk: 'Id Visualizador Pk',
      responsavel: 'Responsavel',
      nome: 'Nome',
      email: 'Email',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
      senha: 'Senha',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListResponsavelVisualizador: {
      idVisualizadorPk: 'Id Visualizador Pk',
      responsavel: 'Responsavel',
      nome: 'Nome',
      email: 'Email',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
      senha: 'Senha',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvResponsavelVisualizador: {
      idVisualizadorPk: 'Id Visualizador Pk',
      responsavel: 'Responsavel',
      nome: 'Nome',
      email: 'Email',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
      senha: 'Senha',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputCargaPesquisaSatisfacao: {
      idCargaFk: 'Id Carga Fk',
      carga: 'Carga',
      notaPergunta1: 'Nota Pergunta 1',
      dataCriacao: 'Data Criacao',
      notaPergunta2: 'Nota Pergunta 2',
      urlFotoSilenciosa: 'Url Foto Silenciosa',
    },
    ListCargaPesquisaSatisfacao: {
      idCargaFk: 'Id Carga Fk',
      carga: 'Carga',
      notaPergunta1: 'Nota Pergunta 1',
      dataCriacao: 'Data Criacao',
      notaPergunta2: 'Nota Pergunta 2',
      urlFotoSilenciosa: 'Url Foto Silenciosa',
    },
    CsvCargaPesquisaSatisfacao: {
      idCargaFk: 'Id Carga Fk',
      carga: 'Carga',
      notaPergunta1: 'Nota Pergunta 1',
      dataCriacao: 'Data Criacao',
      notaPergunta2: 'Nota Pergunta 2',
      urlFotoSilenciosa: 'Url Foto Silenciosa',
    },
    InputAuditoriaTransfolha: {
      idAuditoria: 'Id Auditoria',
      lote: 'Lote',
      json: 'Json',
      dataCriacao: 'Data Criacao',
      reprocessar: 'Reprocessar',
    },
    ListAuditoriaTransfolha: {
      idAuditoria: 'Id Auditoria',
      lote: 'Lote',
      json: 'Json',
      dataCriacao: 'Data Criacao',
      reprocessar: 'Reprocessar',
    },
    CsvAuditoriaTransfolha: {
      idAuditoria: 'Id Auditoria',
      lote: 'Lote',
      json: 'Json',
      dataCriacao: 'Data Criacao',
      reprocessar: 'Reprocessar',
    },
    InputCargaSaraiva: {
      idCargaPk: 'Id Carga Pk',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
      danfe: 'Danfe',
      notaFiscal: 'Nota Fiscal',
      nomeDestinatario: 'Nome Destinatario',
      documentoDestinatario: 'Documento Destinatario',
      enderecoDestinatario: 'Endereco Destinatario',
      nomeTransportador: 'Nome Transportador',
    },
    ListCargaSaraiva: {
      idCargaPk: 'Id Carga Pk',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
      danfe: 'Danfe',
      notaFiscal: 'Nota Fiscal',
      nomeDestinatario: 'Nome Destinatario',
      documentoDestinatario: 'Documento Destinatario',
      enderecoDestinatario: 'Endereco Destinatario',
      nomeTransportador: 'Nome Transportador',
    },
    CsvCargaSaraiva: {
      idCargaPk: 'Id Carga Pk',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
      danfe: 'Danfe',
      notaFiscal: 'Nota Fiscal',
      nomeDestinatario: 'Nome Destinatario',
      documentoDestinatario: 'Documento Destinatario',
      enderecoDestinatario: 'Endereco Destinatario',
      nomeTransportador: 'Nome Transportador',
    },
    InputTipoRelatorio: {
      idTipoRelatorioPk: 'Id Tipo Relatorio Pk',
      formatoArquivoRelatorio: 'Formato Arquivo Relatorio',
      descricao: 'Descricao',
      idFormatoArquivoRelatorioFk: 'Id Formato Arquivo Relatorio Fk',
    },
    ListTipoRelatorio: {
      idTipoRelatorioPk: 'Id Tipo Relatorio Pk',
      formatoArquivoRelatorio: 'Formato Arquivo Relatorio',
      descricao: 'Descricao',
      idFormatoArquivoRelatorioFk: 'Id Formato Arquivo Relatorio Fk',
    },
    CsvTipoRelatorio: {
      idTipoRelatorioPk: 'Id Tipo Relatorio Pk',
      formatoArquivoRelatorio: 'Formato Arquivo Relatorio',
      descricao: 'Descricao',
      idFormatoArquivoRelatorioFk: 'Id Formato Arquivo Relatorio Fk',
    },
    InputAdministrador: {
      idAdministradorPk: 'Id Administrador Pk',
      nome: 'Nome',
      email: 'Email',
      dataCriacao: 'Data Criacao',
      senha: 'Senha',
    },
    ListAdministrador: {
      idAdministradorPk: 'Id Administrador Pk',
      nome: 'Nome',
      email: 'Email',
      dataCriacao: 'Data Criacao',
      senha: 'Senha',
    },
    CsvAdministrador: {
      idAdministradorPk: 'Id Administrador Pk',
      nome: 'Nome',
      email: 'Email',
      dataCriacao: 'Data Criacao',
      senha: 'Senha',
    },
    InputOcorrenciaTracking: {
      idOcorrenciaTracking: 'Id Ocorrencia Tracking',
      carga: 'Carga',
      tipoOcorrencia: 'Tipo Ocorrencia',
      responsavel: 'Responsavel',
      dataOcorrencia: 'Data Ocorrencia',
      descricao: 'Descricao',
      idOcorrenciaExterna: 'Id Ocorrencia Externa',
      idResponsavelFk: 'Id Responsavel Fk',
      idCargaFk: 'Id Carga Fk',
      idOcorrenciaFk: 'Id Ocorrencia Fk',
    },
    InputTipoVeiculo: {
      idTipoVeiculo: 'Id Tipo Veiculo',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    ListOcorrenciaTracking: {
      idOcorrenciaTracking: 'Id Ocorrencia Tracking',
      carga: 'Carga',
      tipoOcorrencia: 'Tipo Ocorrencia',
      responsavel: 'Responsavel',
      dataOcorrencia: 'Data Ocorrencia',
      descricao: 'Descricao',
      idOcorrenciaExterna: 'Id Ocorrencia Externa',
      idResponsavelFk: 'Id Responsavel Fk',
      idCargaFk: 'Id Carga Fk',
      idOcorrenciaFk: 'Id Ocorrencia Fk',
    },
    ListTipoVeiculo: {
      idTipoVeiculo: 'Id Tipo Veículo',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    CsvOcorrenciaTracking: {
      idOcorrenciaTracking: 'Id Ocorrencia Tracking',
      carga: 'Carga',
      tipoOcorrencia: 'Tipo Ocorrencia',
      responsavel: 'Responsavel',
      dataOcorrencia: 'Data Ocorrencia',
      descricao: 'Descricao',
      idOcorrenciaExterna: 'Id Ocorrencia Externa',
      idResponsavelFk: 'Id Responsavel Fk',
      idCargaFk: 'Id Carga Fk',
      idOcorrenciaFk: 'Id Ocorrencia Fk',
    },
    CsvTipoVeiculo: {
      idTipoVeiculo: 'Id Tipo Veículo',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    InputResponsavelAssociado: {
      idAssociadoPk: 'Id Associado Pk',
      responsavel: 'Responsavel',
      razaoSocial: 'Razao Social',
      nomeFantasia: 'Nome Fantasia',
      cnpj: 'Cnpj',
      ativo: 'Ativo',
      senha: 'Senha',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListResponsavelAssociado: {
      idAssociadoPk: 'Id Associado Pk',
      responsavel: 'Responsavel',
      razaoSocial: 'Razao Social',
      nomeFantasia: 'Nome Fantasia',
      cnpj: 'Cnpj',
      ativo: 'Ativo',
      senha: 'Senha',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvResponsavelAssociado: {
      idAssociadoPk: 'Id Associado Pk',
      responsavel: 'Responsavel',
      razaoSocial: 'Razao Social',
      nomeFantasia: 'Nome Fantasia',
      cnpj: 'Cnpj',
      ativo: 'Ativo',
      senha: 'Senha',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputTipoPessoaRecebedor: {
      idTipoPessoaPk: 'ID',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    ListTipoPessoaRecebedor: {
      idTipoPessoaPk: 'ID',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    CsvTipoPessoaRecebedor: {
      idTipoPessoaPk: 'ID',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    InputRequestSsw: {
      idRequestPk: 'Id Request Pk',
      notaFiscal: 'Nota Fiscal',
      json: 'Json',
    },
    ListRequestSsw: {
      idRequestPk: 'Id Request Pk',
      notaFiscal: 'Nota Fiscal',
      json: 'Json',
    },
    CsvRequestSsw: {
      idRequestPk: 'Id Request Pk',
      notaFiscal: 'Nota Fiscal',
      json: 'Json',
    },
    InputResponsavelConfigSms: {
      idConfigSmsPk: 'Id Config Sms Pk',
      responsavel: 'Responsavel',
      idStatusFk: 'Id Status Fk',
      mensagem: 'Mensagem',
      ativo: 'Ativo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListResponsavelConfigSms: {
      idConfigSmsPk: 'Id Config Sms Pk',
      responsavel: 'Responsavel',
      idStatusFk: 'Id Status Fk',
      mensagem: 'Mensagem',
      ativo: 'Ativo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvResponsavelConfigSms: {
      idConfigSmsPk: 'Id Config Sms Pk',
      responsavel: 'Responsavel',
      idStatusFk: 'Id Status Fk',
      mensagem: 'Mensagem',
      ativo: 'Ativo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputResponsavelConfigWhatsapp: {
      idConfigWhatsappPk: 'ID',
      responsavel: 'Responsável',
      status: 'Status SMS',
      whatsappStatus: 'Status Whatsapp',
      ocorrencia: 'Ocorrência',
      mensagem: 'Mensagem',
      ativo: 'Ativo',
      templateId: 'ID Template',
    },
    ListResponsavelConfigWhatsapp: {
      idConfigWhatsappPk: 'ID',
      responsavel: 'Responsável',
      status: 'Status SMS',
      whatsappStatus: 'Status Whatsapp',
      ocorrencia: 'Ocorrência',
      mensagem: 'Mensagem',
      ativo: 'Ativo',
      templateId: 'ID Template',
    },
    CsvResponsavelConfigWhatsapp: {
      idConfigWhatsappPk: 'ID',
      responsavel: 'Responsável',
      status: 'Status SMS',
      whatsappStatus: 'Status Whatsapp',
      ocorrencia: 'Ocorrência',
      mensagem: 'Mensagem',
      ativo: 'Ativo',
      templateId: 'ID Template',
    },
    InputCargaAryzta: {
      idcargaPk: 'Idcarga Pk',
      dataCriacao: 'Data Criacao',
      cgcEmissorNf: 'Cgc Emissor Nf',
      serieNotaFiscal: 'Serie Nota Fiscal',
      danfe: 'Danfe',
      nrNotaFiscal: 'Nr Nota Fiscal',
      siglaCliente: 'Sigla Cliente',
      cepCliente: 'Cep Cliente',
      dataEmissaoNota: 'Data Emissao Nota',
      dataSaidaMerc: 'Data Saida Merc',
      tipoFrete: 'Tipo Frete',
      nomeTransp: 'Nome Transp',
      codigoCfop: 'Codigo Cfop',
      denominacaoCfop: 'Denominacao Cfop',
    },
    ListCargaAryzta: {
      idcargaPk: 'Idcarga Pk',
      dataCriacao: 'Data Criacao',
      cgcEmissorNf: 'Cgc Emissor Nf',
      serieNotaFiscal: 'Serie Nota Fiscal',
      danfe: 'Danfe',
      nrNotaFiscal: 'Nr Nota Fiscal',
      siglaCliente: 'Sigla Cliente',
      cepCliente: 'Cep Cliente',
      dataEmissaoNota: 'Data Emissao Nota',
      dataSaidaMerc: 'Data Saida Merc',
      tipoFrete: 'Tipo Frete',
      nomeTransp: 'Nome Transp',
      codigoCfop: 'Codigo Cfop',
      denominacaoCfop: 'Denominacao Cfop',
    },
    CsvCargaAryzta: {
      idcargaPk: 'Idcarga Pk',
      dataCriacao: 'Data Criacao',
      cgcEmissorNf: 'Cgc Emissor Nf',
      serieNotaFiscal: 'Serie Nota Fiscal',
      danfe: 'Danfe',
      nrNotaFiscal: 'Nr Nota Fiscal',
      siglaCliente: 'Sigla Cliente',
      cepCliente: 'Cep Cliente',
      dataEmissaoNota: 'Data Emissao Nota',
      dataSaidaMerc: 'Data Saida Merc',
      tipoFrete: 'Tipo Frete',
      nomeTransp: 'Nome Transp',
      codigoCfop: 'Codigo Cfop',
      denominacaoCfop: 'Denominacao Cfop',
    },
    InputTokenPush: {
      idTokenPushPk: 'Id Token Push Pk',
      motorista: 'Motorista',
      token: 'Token',
      modeloAparelho: 'Modelo Aparelho',
      marcaAparelho: 'Marca Aparelho',
      idMotoristaFk: 'Id Motorista Fk',
    },
    ListTokenPush: {
      idTokenPushPk: 'Id Token Push Pk',
      motorista: 'Motorista',
      token: 'Token',
      modeloAparelho: 'Modelo Aparelho',
      marcaAparelho: 'Marca Aparelho',
      idMotoristaFk: 'Id Motorista Fk',
    },
    CsvTokenPush: {
      idTokenPushPk: 'Id Token Push Pk',
      motorista: 'Motorista',
      token: 'Token',
      modeloAparelho: 'Modelo Aparelho',
      marcaAparelho: 'Marca Aparelho',
      idMotoristaFk: 'Id Motorista Fk',
    },
    InputCargaCorreios: {
      idCargaCorreiosPk: 'Id Carga Correios Pk',
      carga: 'Carga',
      cdCorreios: 'Cd Correios',
      idCargaFk: 'Id Carga Fk',
    },
    ListCargaCorreios: {
      idCargaCorreiosPk: 'Id Carga Correios Pk',
      carga: 'Carga',
      cdCorreios: 'Cd Correios',
      idCargaFk: 'Id Carga Fk',
    },
    CsvCargaCorreios: {
      idCargaCorreiosPk: 'Id Carga Correios Pk',
      carga: 'Carga',
      cdCorreios: 'Cd Correios',
      idCargaFk: 'Id Carga Fk',
    },
    InputCargaFoto: {
      idFotoPk: 'Id Foto Pk',
      carga: 'Carga',
      urlImagem: 'Url Imagem',
      ehOcorrencia: 'Eh Ocorrencia',
      reprocessar: 'Reprocessar',
      urlBackup: 'Url Backup',
      idCargaFk: 'Id Carga Fk',
    },
    ListCargaFoto: {
      idFotoPk: 'Id Foto Pk',
      carga: 'Carga',
      urlImagem: 'Url Imagem',
      ehOcorrencia: 'Eh Ocorrencia',
      reprocessar: 'Reprocessar',
      urlBackup: 'Url Backup',
      idCargaFk: 'Id Carga Fk',
    },
    CsvCargaFoto: {
      idFotoPk: 'Id Foto Pk',
      carga: 'Carga',
      urlImagem: 'Url Imagem',
      ehOcorrencia: 'Eh Ocorrencia',
      reprocessar: 'Reprocessar',
      urlBackup: 'Url Backup',
      idCargaFk: 'Id Carga Fk',
    },
    InputAuditoriaObservacao: {
      idObservacaoPk: 'Id Observacao Pk',
      carga: 'Carga',
      responsavel: 'Responsavel',
      texto: 'Texto',
      dataEnvio: 'Data Envio',
      idResponsavelFk: 'Id Responsavel Fk',
      idCargaFk: 'Id Carga Fk',
    },
    ListAuditoriaObservacao: {
      idObservacaoPk: 'Id Observacao Pk',
      carga: 'Carga',
      responsavel: 'Responsavel',
      texto: 'Texto',
      dataEnvio: 'Data Envio',
      idResponsavelFk: 'Id Responsavel Fk',
      idCargaFk: 'Id Carga Fk',
    },
    CsvAuditoriaObservacao: {
      idObservacaoPk: 'Id Observacao Pk',
      carga: 'Carga',
      responsavel: 'Responsavel',
      texto: 'Texto',
      dataEnvio: 'Data Envio',
      idResponsavelFk: 'Id Responsavel Fk',
      idCargaFk: 'Id Carga Fk',
    },
    InputCarga: {
      idCargaPk: 'Id Carga Pk',
      sistema1: 'Sistema 1',
      sistema2: 'Sistema 2',
      responsavel: 'Responsavel',
      auditoria: 'Auditoria',
      endereco: 'Endereco',
      motorista: 'Motorista',
      tipoOcorrencia: 'Tipo Ocorrencia',
      posicaoMotorista: 'Posicao Motorista',
      responsavelFilial1: 'Responsavel Filial 1',
      responsavelFilial2: 'Responsavel Filial 2',
      sistema3: 'Sistema 3',
      sistema4: 'Sistema 4',
      statusCarga: 'Status Carga',
      tipoPessoaRecebedor: 'Tipo Pessoa Recebedor',
      cargaCentroDeCusto: 'Carga Centro De Custo',
      danfe: 'Danfe',
      nroNotaFiscal: 'Nro Nota Fiscal',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
      finalizadoViaWeb: 'Finalizado Via Web',
      reprocessarRedesul: 'Reprocessar Redesul',
      processouEasyDoc: 'Processou Easy Doc',
      qtdPaleteEntregue: 'Qtd Palete Entregue',
      qtdPaleteRetirado: 'Qtd Palete Retirado',
      nomeRecebedor: 'Nome Recebedor',
      documentoRecebedor: 'Documento Recebedor',
      rgRecebedor: 'Rg Recebedor',
      idCargaApp: 'Id Carga App',
      codigoBarra: 'Codigo Barra',
      placaVeiculo: 'Placa Veiculo',
      tipoVeiculo: 'Tipo Veiculo',
      nomeMotorista: 'Nome Motorista',
      idResponsavelCriadorFk: 'Id Responsavel Criador Fk',
      idMotoristaCriadorFk: 'Id Motorista Criador Fk',
      serialNumber: 'Serial Number',
      cte: 'Cte',
      protocolSsw: 'Protocol Ssw',
      idEmbarcadorCacheFk: 'Id Embarcador Cache Fk',
      idTransportadorCacheFk: 'Id Transportador Cache Fk',
      sigla: 'Sigla',
      cpfMotorista: 'Cpf Motorista',
      cdCorreio: 'Cd Correio',
      xpedido: 'Xpedido',
      distanciaParaDestinoEmMetros: 'Distancia Para Destino Em Metros',
      duracaoParaDestinoEmSegundos: 'Duracao Para Destino Em Segundos',
      pontoReferenciaEntrega: 'Ponto Referencia Entrega',
      dataEmissaoDanfe: 'Data Emissao Danfe',
      dataInicioEntrega: 'Data Inicio Entrega',
      dataFinalizacao: 'Data Finalizacao',
      observacao: 'Observacao',
      latitudeEntrega: 'Latitude Entrega',
      longitudeEntrega: 'Longitude Entrega',
      devolvida: 'Devolvida',
      latitudeCheckIn: 'Latitude Check In',
      longitudeCheckIn: 'Longitude Check In',
      dataCheckIn: 'Data Check In',
      dataPrevisao: 'Data Previsao',
      possuiDanfe: 'Possui Danfe',
      criadoViaPainel: 'Criado Via Painel',
      dataBaixaSistema: 'Data Baixa Sistema',
      dataRemocao: 'Data Remocao',
      distanciaCheckInEmMetros: 'Distancia Check In Em Metros',
      distanciaEntregaEmMetros: 'Distancia Entrega Em Metros',
      idMotoristaFk: 'Id Motorista Fk',
      idOcorrenciaFk: 'Id Ocorrencia Fk',
      idEnderecoFk: 'Id Endereco Fk',
      idUltimaPosicaoMotoristaFk: 'Id Ultima Posicao Motorista Fk',
      idSistemaCriadorFk: 'Id Sistema Criador Fk',
      idSistemaFinalizadorFk: 'Id Sistema Finalizador Fk',
      idSistemaRemovedorFk: 'Id Sistema Removedor Fk',
      idRemovedorFk: 'Id Removedor Fk',
      idUltimaAuditoriaFk: 'Id Ultima Auditoria Fk',
      idFilialEmbarcadorFk: 'Id Filial Embarcador Fk',
      idFilialTransportadorFk: 'Id Filial Transportador Fk',
      idPessoaRecebedorFk: 'Id Pessoa Recebedor Fk',
      idStatusFk: 'Id Status Fk',
    },
    ListCarga: {
      idCargaPk: 'Id Carga Pk',
      sistema1: 'Sistema 1',
      sistema2: 'Sistema 2',
      responsavel: 'Responsavel',
      auditoria: 'Auditoria',
      endereco: 'Endereco',
      motorista: 'Motorista',
      tipoOcorrencia: 'Tipo Ocorrencia',
      posicaoMotorista: 'Posicao Motorista',
      responsavelFilial1: 'Responsavel Filial 1',
      responsavelFilial2: 'Responsavel Filial 2',
      sistema3: 'Sistema 3',
      sistema4: 'Sistema 4',
      statusCarga: 'Status Carga',
      tipoPessoaRecebedor: 'Tipo Pessoa Recebedor',
      cargaCentroDeCusto: 'Carga Centro De Custo',
      danfe: 'Danfe',
      nroNotaFiscal: 'Nro Nota Fiscal',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
      finalizadoViaWeb: 'Finalizado Via Web',
      reprocessarRedesul: 'Reprocessar Redesul',
      processouEasyDoc: 'Processou Easy Doc',
      qtdPaleteEntregue: 'Qtd Palete Entregue',
      qtdPaleteRetirado: 'Qtd Palete Retirado',
      nomeRecebedor: 'Nome Recebedor',
      documentoRecebedor: 'Documento Recebedor',
      rgRecebedor: 'Rg Recebedor',
      idCargaApp: 'Id Carga App',
      codigoBarra: 'Codigo Barra',
      placaVeiculo: 'Placa Veiculo',
      tipoVeiculo: 'Tipo Veiculo',
      nomeMotorista: 'Nome Motorista',
      idResponsavelCriadorFk: 'Id Responsavel Criador Fk',
      idMotoristaCriadorFk: 'Id Motorista Criador Fk',
      serialNumber: 'Serial Number',
      cte: 'Cte',
      protocolSsw: 'Protocol Ssw',
      idEmbarcadorCacheFk: 'Id Embarcador Cache Fk',
      idTransportadorCacheFk: 'Id Transportador Cache Fk',
      sigla: 'Sigla',
      cpfMotorista: 'Cpf Motorista',
      cdCorreio: 'Cd Correio',
      xpedido: 'Xpedido',
      distanciaParaDestinoEmMetros: 'Distancia Para Destino Em Metros',
      duracaoParaDestinoEmSegundos: 'Duracao Para Destino Em Segundos',
      pontoReferenciaEntrega: 'Ponto Referencia Entrega',
      dataEmissaoDanfe: 'Data Emissao Danfe',
      dataInicioEntrega: 'Data Inicio Entrega',
      dataFinalizacao: 'Data Finalizacao',
      observacao: 'Observacao',
      latitudeEntrega: 'Latitude Entrega',
      longitudeEntrega: 'Longitude Entrega',
      devolvida: 'Devolvida',
      latitudeCheckIn: 'Latitude Check In',
      longitudeCheckIn: 'Longitude Check In',
      dataCheckIn: 'Data Check In',
      dataPrevisao: 'Data Previsao',
      possuiDanfe: 'Possui Danfe',
      criadoViaPainel: 'Criado Via Painel',
      dataBaixaSistema: 'Data Baixa Sistema',
      dataRemocao: 'Data Remocao',
      distanciaCheckInEmMetros: 'Distancia Check In Em Metros',
      distanciaEntregaEmMetros: 'Distancia Entrega Em Metros',
      idMotoristaFk: 'Id Motorista Fk',
      idOcorrenciaFk: 'Id Ocorrencia Fk',
      idEnderecoFk: 'Id Endereco Fk',
      idUltimaPosicaoMotoristaFk: 'Id Ultima Posicao Motorista Fk',
      idSistemaCriadorFk: 'Id Sistema Criador Fk',
      idSistemaFinalizadorFk: 'Id Sistema Finalizador Fk',
      idSistemaRemovedorFk: 'Id Sistema Removedor Fk',
      idRemovedorFk: 'Id Removedor Fk',
      idUltimaAuditoriaFk: 'Id Ultima Auditoria Fk',
      idFilialEmbarcadorFk: 'Id Filial Embarcador Fk',
      idFilialTransportadorFk: 'Id Filial Transportador Fk',
      idPessoaRecebedorFk: 'Id Pessoa Recebedor Fk',
      idStatusFk: 'Id Status Fk',
    },
    CsvCarga: {
      idCargaPk: 'Id Carga Pk',
      sistema1: 'Sistema 1',
      sistema2: 'Sistema 2',
      responsavel: 'Responsavel',
      auditoria: 'Auditoria',
      endereco: 'Endereco',
      motorista: 'Motorista',
      tipoOcorrencia: 'Tipo Ocorrencia',
      posicaoMotorista: 'Posicao Motorista',
      responsavelFilial1: 'Responsavel Filial 1',
      responsavelFilial2: 'Responsavel Filial 2',
      sistema3: 'Sistema 3',
      sistema4: 'Sistema 4',
      statusCarga: 'Status Carga',
      tipoPessoaRecebedor: 'Tipo Pessoa Recebedor',
      cargaCentroDeCusto: 'Carga Centro De Custo',
      danfe: 'Danfe',
      nroNotaFiscal: 'Nro Nota Fiscal',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
      finalizadoViaWeb: 'Finalizado Via Web',
      reprocessarRedesul: 'Reprocessar Redesul',
      processouEasyDoc: 'Processou Easy Doc',
      qtdPaleteEntregue: 'Qtd Palete Entregue',
      qtdPaleteRetirado: 'Qtd Palete Retirado',
      nomeRecebedor: 'Nome Recebedor',
      documentoRecebedor: 'Documento Recebedor',
      rgRecebedor: 'Rg Recebedor',
      idCargaApp: 'Id Carga App',
      codigoBarra: 'Codigo Barra',
      placaVeiculo: 'Placa Veiculo',
      tipoVeiculo: 'Tipo Veiculo',
      nomeMotorista: 'Nome Motorista',
      idResponsavelCriadorFk: 'Id Responsavel Criador Fk',
      idMotoristaCriadorFk: 'Id Motorista Criador Fk',
      serialNumber: 'Serial Number',
      cte: 'Cte',
      protocolSsw: 'Protocol Ssw',
      idEmbarcadorCacheFk: 'Id Embarcador Cache Fk',
      idTransportadorCacheFk: 'Id Transportador Cache Fk',
      sigla: 'Sigla',
      cpfMotorista: 'Cpf Motorista',
      cdCorreio: 'Cd Correio',
      xpedido: 'Xpedido',
      distanciaParaDestinoEmMetros: 'Distancia Para Destino Em Metros',
      duracaoParaDestinoEmSegundos: 'Duracao Para Destino Em Segundos',
      pontoReferenciaEntrega: 'Ponto Referencia Entrega',
      dataEmissaoDanfe: 'Data Emissao Danfe',
      dataInicioEntrega: 'Data Inicio Entrega',
      dataFinalizacao: 'Data Finalizacao',
      observacao: 'Observacao',
      latitudeEntrega: 'Latitude Entrega',
      longitudeEntrega: 'Longitude Entrega',
      devolvida: 'Devolvida',
      latitudeCheckIn: 'Latitude Check In',
      longitudeCheckIn: 'Longitude Check In',
      dataCheckIn: 'Data Check In',
      dataPrevisao: 'Data Previsao',
      possuiDanfe: 'Possui Danfe',
      criadoViaPainel: 'Criado Via Painel',
      dataBaixaSistema: 'Data Baixa Sistema',
      dataRemocao: 'Data Remocao',
      distanciaCheckInEmMetros: 'Distancia Check In Em Metros',
      distanciaEntregaEmMetros: 'Distancia Entrega Em Metros',
      idMotoristaFk: 'Id Motorista Fk',
      idOcorrenciaFk: 'Id Ocorrencia Fk',
      idEnderecoFk: 'Id Endereco Fk',
      idUltimaPosicaoMotoristaFk: 'Id Ultima Posicao Motorista Fk',
      idSistemaCriadorFk: 'Id Sistema Criador Fk',
      idSistemaFinalizadorFk: 'Id Sistema Finalizador Fk',
      idSistemaRemovedorFk: 'Id Sistema Removedor Fk',
      idRemovedorFk: 'Id Removedor Fk',
      idUltimaAuditoriaFk: 'Id Ultima Auditoria Fk',
      idFilialEmbarcadorFk: 'Id Filial Embarcador Fk',
      idFilialTransportadorFk: 'Id Filial Transportador Fk',
      idPessoaRecebedorFk: 'Id Pessoa Recebedor Fk',
      idStatusFk: 'Id Status Fk',
    },
    ListCargo: {
      idCargoPk: 'Id Cargo Pk',
      document: 'Document',
      emissionDate: 'Emission Date',
      deliveryDate: 'Delivery Date',
      systemDeliveryDate: 'System Delivery Date',
      creationDate: 'Creation Date',
      expectedDate: 'Expected Date',
      active: 'Active',
      note: 'Note',
      idCreatorSystemFk: 'Id Creator System Fk',
      idFinisherSystemFk: 'Id Finisher System Fk',
      idCargoStatusFk: 'Id Cargo Status Fk',
      idTransporterFk: 'Id Transporter Fk',
      idShipperFk: 'Id Shipper Fk',
      idPanelUserCreatorFk: 'Id Panel User Creator Fk',
      idDriverFk: 'Id Driver Fk',
      idReceptorFk: 'Id Receptor Fk',
      dte: 'DTE',
      idAddressFk: 'Id Address Fk',
      idOccurrenceFk: 'Id Occurrence Fk',
      idDocumentPhotoFk: 'Id Document Photo Fk',
      returned: 'Returned',
      idVisualizationModeFk: 'Id Visualization Mode Fk',
    },
    CsvCargo: {
      idCargoPk: 'Id Cargo Pk',
      document: 'Document',
      emissionDate: 'Emission Date',
      deliveryDate: 'Delivery Date',
      systemDeliveryDate: 'System Delivery Date',
      creationDate: 'Creation Date',
      expectedDate: 'Expected Date',
      active: 'Active',
      note: 'Note',
      idCreatorSystemFk: 'Id Creator System Fk',
      idFinisherSystemFk: 'Id Finisher System Fk',
      idCargoStatusFk: 'Id Cargo Status Fk',
      idTransporterFk: 'Id Transporter Fk',
      idShipperFk: 'Id Shipper Fk',
      idPanelUserCreatorFk: 'Id Panel User Creator Fk',
      idDriverFk: 'Id Driver Fk',
      idReceptorFk: 'Id Receptor Fk',
      dte: 'DTE',
      idAddressFk: 'Id Address Fk',
      idOccurrenceFk: 'Id Occurrence Fk',
      idDocumentPhotoFk: 'Id Document Photo Fk',
      returned: 'Returned',
      idVisualizationModeFk: 'Id Visualization Mode Fk',
    },
    InputCargaTransfolha: {
      idCargaTransfolhaPk: 'Id Carga Transfolha Pk',
      carga: 'Carga',
      pedido: 'Pedido',
      lote: 'Lote',
      lastIdCodigo: 'Last Id Codigo',
      dateLastEvent: 'Date Last Event',
      hourLastEvent: 'Hour Last Event',
      lastDateTry: 'Last Date Try',
      idCargaFk: 'Id Carga Fk',
    },
    ListCargaTransfolha: {
      idCargaTransfolhaPk: 'Id Carga Transfolha Pk',
      carga: 'Carga',
      pedido: 'Pedido',
      lote: 'Lote',
      lastIdCodigo: 'Last Id Codigo',
      dateLastEvent: 'Date Last Event',
      hourLastEvent: 'Hour Last Event',
      lastDateTry: 'Last Date Try',
      idCargaFk: 'Id Carga Fk',
    },
    CsvCargaTransfolha: {
      idCargaTransfolhaPk: 'Id Carga Transfolha Pk',
      carga: 'Carga',
      pedido: 'Pedido',
      lote: 'Lote',
      lastIdCodigo: 'Last Id Codigo',
      dateLastEvent: 'Date Last Event',
      hourLastEvent: 'Hour Last Event',
      lastDateTry: 'Last Date Try',
      idCargaFk: 'Id Carga Fk',
    },
    InputSistema: {
      idSistemaPk: 'Id Sistema Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    ListSistema: {
      idSistemaPk: 'Id Sistema Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    CsvSistema: {
      idSistemaPk: 'Id Sistema Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    InputEmailDestinatario: {
      idEmailDestinatarioPk: 'Id Email Destinatario Pk',
      responsavel: 'Responsavel',
      cpfCnpj: 'Cpf Cnpj',
      email: 'Email',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListEmailDestinatario: {
      idEmailDestinatarioPk: 'Id Email Destinatario Pk',
      responsavel: 'Responsavel',
      cpfCnpj: 'Cpf Cnpj',
      email: 'Email',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvEmailDestinatario: {
      idEmailDestinatarioPk: 'Id Email Destinatario Pk',
      responsavel: 'Responsavel',
      cpfCnpj: 'Cpf Cnpj',
      email: 'Email',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputFaturamentoConfiguracao: {
      responsavel: 'Responsável',
      diaInicial: 'Dia Inicial',
      diaFinal: 'Dia Final',
      ehGrupoEconomico: 'Grupo Econômico',
      ativo: 'Ativo',
      idResponsavelFk: 'ID Responsavel',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      nomeFantasia: 'Nome Fantasia',
      dataVencimentoContrato: 'Data Vencimento Contrato',
      dataUltimaCorrecao: 'Data Última Correção',
      numeroProtheus: 'Número Protheus',
      observacao: 'Observação',
      valorIroute: 'iRoute',
      valorCheckinAutomatico: 'Check-in Automático',
      valorExibirMapaSacPainel: 'Exibir Mapa no SAC Painel',
      valorBi: 'Bi',
      valorNotificacaoSMS: 'Notificação por SMS',
      valorVoip: 'VOIP',
      valorTorreControle: 'Torre de Controle',
      valorNotificacaoWhatsup: 'Notificação por WhatsApp',
      valorAcessoLimitadoTransportadores:
        'Acesso Ilimitado aos Transportadores',
      valorCheckList: 'Checklist',
      valorConsultaPedido: 'Consulta Pedido',
      valorContraSenha: 'Contra Senha',
      warning: 'Responsável não configurado',
      success: 'Responsável configurado com sucesso',
      noResultLabel: 'Nenhum Responsável encontrado',
      noOptionsLabel: 'Lista vazia',
    },
    InputFaixaFaturamentoConfiguracao: {
      nomeFaixa: 'Nome',
      volumeInicial: 'Parâmetro Inicial',
      volumeFinal: 'Parâmetro Final',
      valorFaixa: 'Valor R$',
    },
    ListFaturamento: {
      title: 'Relatório Faturamento',
      responsavel: 'ID',
      nomeFantasia: 'Nome Fantasia',
      razaoSocial: 'Razão Social',
      configDiaInicialDaGeracao: 'Dia Inicial',
      configDiaFinalDaGeracao: 'Dia Final',
      tipoRelatorio: 'Tipo de Geração',
      dataGeracaoFaturamento: 'Data da Geração',
      linkGeracaoRelatorio: 'Link do Relatório',
      cnpj: 'CNPJ',
    },
    CsvFaturamento: {
      responsavel: 'ID Responsável',
      nomeFantasia: 'Nome Fantasia',
      razaoSocial: 'Razão Social',
      configDiaInicialDaGeracao: 'Dia Inicial',
      configDiaFinalDaGeracao: 'Dia Final',
      tipoRelatorio: 'Tipo de Geração',
      dataGeracaoFaturamento: 'Data da Geração',
      linkGeracaoRelatorio: 'Link do Relatório',
      cnpj: 'CNPJ',
      volumeNotasAnterior: 'Volume Notas Mês Anterior',
      volumeNotas: 'Volume notas Mês Atual',
      dataVencimentoContrato: 'Data Vencimento do Contrato',
      dataUltimaCorrecao: 'Data Última Correção',
      numeroProtheus: 'Número Protheus',
      observacao: 'Observação',
      faixaCalculadaAnterior: 'Faixa Mês Anterior',
      faixaCalculada: 'Faixa Mês Atual',
      valorIroute: 'iRoute',
      valorBi: 'Bi',
      valorTorreControle: 'Torre de Controle',
      valorAcessoLimitadoTransportadores: 'Acesso Ilimitado Transportadores',
      valorCheckinAutomatico: 'Check-in Automático',
      valorConsultaPedido: 'Consulta Pedido',
      valorNotificacaoSMS: 'Notificação por SMS',
      valorNotificacaoWhatsup: 'Notificação por WhatsApp',
      valorContraSenha: 'Contra Senha',
      valorCheckList: 'Checklist',
      valorExibirMapaSacPainel: 'Exibir mapa no SAC Painel',
      valorVoip: 'VOIP',
    },
    InputResponseRoboCnpj: {
      idResponsePk: 'Id Response Pk',
      cnpj: 'Cnpj',
      response: 'Response',
    },
    ListResponseRoboCnpj: {
      idResponsePk: 'Id Response Pk',
      cnpj: 'Cnpj',
      response: 'Response',
    },
    CsvResponseRoboCnpj: {
      idResponsePk: 'Id Response Pk',
      cnpj: 'Cnpj',
      response: 'Response',
    },
    InputCargaKarcher: {
      idCargaInfoPk: 'Id Carga Info Pk',
      carga: 'Carga',
      nomeArquivo: 'Nome Arquivo',
      dataInicioDownload: 'Data Inicio Download',
      idCargaFk: 'Id Carga Fk',
    },
    ListCargaKarcher: {
      idCargaInfoPk: 'Id Carga Info Pk',
      carga: 'Carga',
      nomeArquivo: 'Nome Arquivo',
      dataInicioDownload: 'Data Inicio Download',
      idCargaFk: 'Id Carga Fk',
    },
    CsvCargaKarcher: {
      idCargaInfoPk: 'Id Carga Info Pk',
      carga: 'Carga',
      nomeArquivo: 'Nome Arquivo',
      dataInicioDownload: 'Data Inicio Download',
      idCargaFk: 'Id Carga Fk',
    },
    InputCargaDestinatario: {
      idCargaFk: 'Id Carga Fk',
      carga: 'Carga',
      endereco: 'Endereco',
      nome: 'Nome',
      cpfCnpj: 'Cpf Cnpj',
      telefone: 'Telefone',
      indicadorIe: 'Indicador Ie',
      inscricaoEstadual: 'Inscricao Estadual',
      inscricaoSuframa: 'Inscricao Suframa',
      im: 'Im',
      email: 'Email',
      idEnderecoFk: 'Id Endereco Fk',
    },
    ListCargaDestinatario: {
      idCargaFk: 'Id Carga Fk',
      carga: 'Carga',
      endereco: 'Endereco',
      nome: 'Nome',
      cpfCnpj: 'Cpf Cnpj',
      telefone: 'Telefone',
      indicadorIe: 'Indicador Ie',
      inscricaoEstadual: 'Inscricao Estadual',
      inscricaoSuframa: 'Inscricao Suframa',
      im: 'Im',
      email: 'Email',
      idEnderecoFk: 'Id Endereco Fk',
    },
    CsvCargaDestinatario: {
      idCargaFk: 'Id Carga Fk',
      carga: 'Carga',
      endereco: 'Endereco',
      nome: 'Nome',
      cpfCnpj: 'Cpf Cnpj',
      telefone: 'Telefone',
      indicadorIe: 'Indicador Ie',
      inscricaoEstadual: 'Inscricao Estadual',
      inscricaoSuframa: 'Inscricao Suframa',
      im: 'Im',
      email: 'Email',
      idEnderecoFk: 'Id Endereco Fk',
    },
    InputMotoristaTransbordo: {
      idMotoristaFk: 'Id Motorista Fk',
      motorista: 'Motorista',
      podeReceber: 'Pode Receber',
      podeEntregar: 'Pode Entregar',
    },
    ListMotoristaTransbordo: {
      idMotoristaFk: 'Id Motorista Fk',
      motorista: 'Motorista',
      podeReceber: 'Pode Receber',
      podeEntregar: 'Pode Entregar',
    },
    CsvMotoristaTransbordo: {
      idMotoristaFk: 'Id Motorista Fk',
      motorista: 'Motorista',
      podeReceber: 'Pode Receber',
      podeEntregar: 'Pode Entregar',
    },
    InputBanner: {
      idBannerPk: 'Id Banner Pk',
      nome: 'Nome',
      urlImagem: 'Url Imagem',
      urlRedirect: 'Url Redirect',
      dataInicio: 'Data Inicio',
      dataFim: 'Data Fim',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
    },
    ListBanner: {
      idBannerPk: 'Id Banner Pk',
      nome: 'Nome',
      urlImagem: 'Url Imagem',
      urlRedirect: 'Url Redirect',
      dataInicio: 'Data Inicio',
      dataFim: 'Data Fim',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
    },
    CsvBanner: {
      idBannerPk: 'Id Banner Pk',
      nome: 'Nome',
      urlImagem: 'Url Imagem',
      urlRedirect: 'Url Redirect',
      dataInicio: 'Data Inicio',
      dataFim: 'Data Fim',
      dataCriacao: 'Data Criacao',
      ativo: 'Ativo',
    },
    InputCargaResponsavel: {
      idCargaFk: 'Id Carga Fk',
      ehEmbarcador: 'Eh Embarcador',
      carga: 'Carga',
      endereco: 'Endereco',
      responsavel: 'Responsavel',
      responsavelFilial: 'Responsavel Filial',
      inscricaoEstadual: 'Inscricao Estadual',
      substitutoTributario: 'Substituto Tributario',
      inscricaoMunicipal: 'Inscricao Municipal',
      municipioIcms: 'Municipio Icms',
      cnaeFiscal: 'Cnae Fiscal',
      codigoRegimeTributario: 'Codigo Regime Tributario',
      idResponsavelFk: 'Id Responsavel Fk',
      idEnderecoFk: 'Id Endereco Fk',
      idFilialFk: 'Id Filial Fk',
    },
    ListCargaResponsavel: {
      idCargaFk: 'Id Carga Fk',
      ehEmbarcador: 'Eh Embarcador',
      carga: 'Carga',
      endereco: 'Endereco',
      responsavel: 'Responsavel',
      responsavelFilial: 'Responsavel Filial',
      inscricaoEstadual: 'Inscricao Estadual',
      substitutoTributario: 'Substituto Tributario',
      inscricaoMunicipal: 'Inscricao Municipal',
      municipioIcms: 'Municipio Icms',
      cnaeFiscal: 'Cnae Fiscal',
      codigoRegimeTributario: 'Codigo Regime Tributario',
      idResponsavelFk: 'Id Responsavel Fk',
      idEnderecoFk: 'Id Endereco Fk',
      idFilialFk: 'Id Filial Fk',
    },
    CsvCargaResponsavel: {
      idCargaFk: 'Id Carga Fk',
      ehEmbarcador: 'Eh Embarcador',
      carga: 'Carga',
      endereco: 'Endereco',
      responsavel: 'Responsavel',
      responsavelFilial: 'Responsavel Filial',
      inscricaoEstadual: 'Inscricao Estadual',
      substitutoTributario: 'Substituto Tributario',
      inscricaoMunicipal: 'Inscricao Municipal',
      municipioIcms: 'Municipio Icms',
      cnaeFiscal: 'Cnae Fiscal',
      codigoRegimeTributario: 'Codigo Regime Tributario',
      idResponsavelFk: 'Id Responsavel Fk',
      idEnderecoFk: 'Id Endereco Fk',
      idFilialFk: 'Id Filial Fk',
    },
    InputResponsavelHistoricoSms: {
      idHistoricoPk: 'Id Historico Pk',
      carga: 'Carga',
      motorista: 'Motorista',
      typeSms: 'Type Sms',
      responsavel: 'Responsavel',
      nomeDestinatario: 'Nome Destinatario',
      mensagem: 'Mensagem',
      dataEnvio: 'Data Envio',
      nfe: 'Nfe',
      telefone: 'Telefone',
      idResponsavelFk: 'Id Responsavel Fk',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
      idTypeFk: 'Id Type Fk',
    },
    ListResponsavelHistoricoSms: {
      idHistoricoPk: 'Id Historico Pk',
      carga: 'Carga',
      motorista: 'Motorista',
      typeSms: 'Type Sms',
      responsavel: 'Responsavel',
      nomeDestinatario: 'Nome Destinatario',
      mensagem: 'Mensagem',
      dataEnvio: 'Data Envio',
      nfe: 'Nfe',
      telefone: 'Telefone',
      idResponsavelFk: 'Id Responsavel Fk',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
      idTypeFk: 'Id Type Fk',
    },
    CsvResponsavelHistoricoSms: {
      idHistoricoPk: 'Id Historico Pk',
      carga: 'Carga',
      motorista: 'Motorista',
      typeSms: 'Type Sms',
      responsavel: 'Responsavel',
      nomeDestinatario: 'Nome Destinatario',
      mensagem: 'Mensagem',
      dataEnvio: 'Data Envio',
      nfe: 'Nfe',
      telefone: 'Telefone',
      idResponsavelFk: 'Id Responsavel Fk',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
      idTypeFk: 'Id Type Fk',
    },
    InputMotorista: {
      idMotoristaPk: 'ID',
      endereco: 'Endereço',
      placaVeiculo: 'Placa Veículo',
      codigoSms: 'Codigo SMS',
      urlImagem: 'URL Imagem',
      nome: 'Nome',
      cpf: 'CPF',
      rg: 'RG',
      celular: 'Celular',
      tipoVeiculoAsResource: 'Tipo de Veículo',
      tipoVeiculoFkAsResource: 'Tipo de Veículo',
      dataNascimento: 'Data de Nascimento',
      dataCriacao: 'Data Criação',
      ativo: 'Ativo',
      email: 'Email',
      telefoneFixo: 'Telefone Fixo',
      tipoCarreta: 'Tipo de Carreta',
      tipoCarroceriaAsResource: 'Tipo de Carroceria',
      placaCarroceira: 'Placa da Carroceria',
      antt: 'ANTT',
      rntrc: 'RNTRC',
      cnh: 'CNH',
      marcaVeiculoAsResource: 'Marca do Veículo',
      idResponsavelCriadorFk: 'ID Responsavel Criador Fk',
      nomeIndicador: 'Nome Indicador',
      tokenAndroid: 'Token Android',
      versao: 'Versão do App',
      senha: 'Senha',
      idEnderecoFk: 'ID Endereco Fk',
      lastUpdateDate: 'Data última modificação',
      lastUpdateName: 'Última modificação',
    },
    ListMotorista: {
      idMotoristaPk: 'ID',
      marcaAparelho: 'Marca do Celular',
      modeloAparelho: 'Modelo do Celular',
      endereco: 'Endereço',
      nomeCriador: 'Cadastrado Por',
      placaVeiculo: 'Placa Veículo',
      codigoSms: 'Codigo SMS',
      urlImagem: 'URL Imagem',
      nome: 'Nome',
      cpf: 'CPF',
      rg: 'RG',
      celular: 'Celular',
      tipoVeiculo: 'Tipo de Veículo',
      dataNascimento: 'Data Nascimento',
      dataCriacao: 'Data Criação',
      ativo: 'Ativo',
      email: 'Email',
      telefoneFixo: 'Telefone Fixo',
      tipoCarreta: 'Tipo de Carreta',
      tipoCarroceria: 'Tipo de Carroceria',
      placaCarroceira: 'Placa da Carroceria',
      antt: 'ANTT',
      rntrc: 'RNTRC',
      cnh: 'CNH',
      marcaVeiculo: 'Marca do Veículo',
      idResponsavelCriadorFk: 'ID Responsavel Criador Fk',
      nomeIndicador: 'Nome Indicador',
      tokenAndroid: 'Token Android',
      versao: 'Versão do App',
      senha: 'Senha',
      idEnderecoFk: 'ID Endereco Fk',
      selectToNotify: 'Selecionar para notificar',
      notifyAll: 'Notificar todos',
      notifyTitle: 'Mensagem:',
      emptyMotorista: 'Nenhum motorista selecionado',
      successMessage: 'Mensagem enviada com sucesso',
    },
    CsvMotorista: {
      title: 'entregadores',
      idMotoristaPk: 'ID',
      endereco: 'Endereço',
      placaVeiculo: 'Placa do Veículo',
      codigoSms: 'Codigo SMS',
      urlImagem: 'URL Imagem',
      nome: 'Nome',
      cpf: 'CPF',
      rg: 'RG',
      celular: 'Celular',
      tipoVeiculo: 'Tipo de Veículo',
      dataNascimento: 'Data de Nascimento',
      dataCriacao: 'Data de Cadastro',
      ativo: 'Ativo',
      email: 'E-Mail',
      telefoneFixo: 'Telefone Fixo',
      tipoCarreta: 'Tipo de Carreta',
      tipoCarroceria: 'Tipo de Carroceria',
      placaCarroceira: 'Placa da Carroceira',
      antt: 'ANTT',
      rntrc: 'RNTRC',
      cnh: 'CNH',
      marcaVeiculo: 'Marca do Veículo',
      idResponsavelCriadorFk: 'ID do Responsável que Cadastrou',
      nomeIndicador: 'Nome Indicador',
      tokenAndroid: 'Token Android',
      versao: 'Versão do App',
      senha: 'Senha',
      idEnderecoFk: 'ID do Responsável que Cadastrou',
      cep: 'CEP',
      logradouro: 'Logradouro',
      bairro: 'Bairro',
      cidade: 'Cidade',
      uf: 'UF',
      marcaAparelho: 'Marca do Aparelho',
      modeloAparelho: 'Modelo do Aparelho',
      nomeResponsavelUltimaAlteracao: 'Responsável Última modificação',
      dataUltimaModificacao: 'Data da última modificação',
    },
    InputCargaTemp: {
      idCargaPk: 'Id Carga Pk',
    },
    ListCargaTemp: {
      idCargaPk: 'Id Carga Pk',
    },
    CsvCargaTemp: {
      idCargaPk: 'Id Carga Pk',
    },
    InputAdminConfig: {
      idConfigPk: 'Id Config Pk',
      autorizarMesmoVencido: 'Autorizar Mesmo Vencido',
      senhaApp: 'Senha App',
      senhaPainel: 'Senha Painel',
      indiqueUmAmigo: 'Indique Um Amigo',
      boasVindas: 'Boas Vindas',
      utilizarSmsZenvia: 'Utilizar SMS de Zenvia',
      salvarLogsRequestSSW: 'Salvar Log das Requests da SSW',
      raioAuditoriaCheckinMetros: 'Raio Auditoria Checkin Metros',
      raioAuditoriaEntregaMetros: 'Raio Auditoria Entrega Metros',
      repetirSenhaApp: 'Repetir Senha App',
      repetirSenhaPainel: 'Repetir Senha Painel',
      updatePasswords: 'Atualizar Senhas',
      lastUpdateDate: 'Data última modificação',
      lastUpdateName: 'Última modificação',
      permitirNotificacaoEmailAtlas: 'Notificação E-mail Atlas',
      permitirNotificacaoSmsAtlas: 'Notificação SMS Atlas',
    },
    InputAdminConfigInternational: {
      panelPassword: 'Senha Painel',
      repeatPanelPassword: 'Repetir Senha Painel',
      lastUpdateDate: 'Data última modificação',
      lastUpdateName: 'Última modificação',
      updatePasswords: 'Atualizar Senhas',
    },
    ListAdminConfig: {
      idConfigPk: 'Id Config Pk',
      autorizarMesmoVencido: 'Autorizar Mesmo Vencido',
      senhaApp: 'Senha App',
      senhaPainel: 'Senha Painel',
      indiqueUmAmigo: 'Indique Um Amigo',
      boasVindas: 'Boas Vindas',
    },
    CsvAdminConfig: {
      idConfigPk: 'Id Config Pk',
      autorizarMesmoVencido: 'Autorizar Mesmo Vencido',
      senhaApp: 'Senha App',
      senhaPainel: 'Senha Painel',
      indiqueUmAmigo: 'Indique Um Amigo',
      boasVindas: 'Boas Vindas',
    },
    InputRotaSla: {
      idResponsavelFk: 'Id Responsavel Fk',
      idOrigemFk: 'Id Origem Fk',
      idDestinoFk: 'Id Destino Fk',
      pontaSla1: 'Ponta Sla 1',
      pontaSla2: 'Ponta Sla 2',
      responsavel: 'Responsavel',
      valor: 'Valor',
    },
    ListRotaSla: {
      idResponsavelFk: 'Id Responsavel Fk',
      idOrigemFk: 'Id Origem Fk',
      idDestinoFk: 'Id Destino Fk',
      pontaSla1: 'Ponta Sla 1',
      pontaSla2: 'Ponta Sla 2',
      responsavel: 'Responsavel',
      valor: 'Valor',
    },
    CsvRotaSla: {
      idResponsavelFk: 'Id Responsavel Fk',
      idOrigemFk: 'Id Origem Fk',
      idDestinoFk: 'Id Destino Fk',
      pontaSla1: 'Ponta Sla 1',
      pontaSla2: 'Ponta Sla 2',
      responsavel: 'Responsavel',
      valor: 'Valor',
    },
    InputFormatoArquivoRelatorio: {
      idFormatoArquivoRelatorioPk: 'Id Formato Arquivo Relatorio Pk',
      descricao: 'Descricao',
    },
    ListFormatoArquivoRelatorio: {
      idFormatoArquivoRelatorioPk: 'Id Formato Arquivo Relatorio Pk',
      descricao: 'Descricao',
    },
    CsvFormatoArquivoRelatorio: {
      idFormatoArquivoRelatorioPk: 'Id Formato Arquivo Relatorio Pk',
      descricao: 'Descricao',
    },
    InputMotoristaCancelamentoCarga: {
      idCancelamentoPk: 'Id Cancelamento Pk',
      carga: 'Carga',
      motorista: 'Motorista',
      data: 'Data',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
    },
    ListMotoristaCancelamentoCarga: {
      idCancelamentoPk: 'Id Cancelamento Pk',
      carga: 'Carga',
      motorista: 'Motorista',
      data: 'Data',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
    },
    CsvMotoristaCancelamentoCarga: {
      idCancelamentoPk: 'Id Cancelamento Pk',
      carga: 'Carga',
      motorista: 'Motorista',
      data: 'Data',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
    },
    InputAuditoria: {
      idAuditoriaPk: 'Id Auditoria Pk',
      auditoriaMotivo: 'Motivo para Auditoria',
      carga: 'Carga',
      responsavel: 'Responsavel',
      conforme: 'Conforme',
      dataCriacao: 'Data Criacao',
      dataCanhoto: 'Data Canhoto',
      idResponsavelFk: 'Id Responsavel Fk',
      idCargaFk: 'Id Carga Fk',
      idMotivoFk: 'Id Motivo Fk',
    },
    ListAuditoria: {
      idAuditoriaPk: 'Id Auditoria Pk',
      auditoriaMotivo: 'Motivo para Auditoria',
      carga: 'Carga',
      responsavel: 'Responsavel',
      conforme: 'Conforme',
      dataCriacao: 'Data Criacao',
      dataCanhoto: 'Data Canhoto',
      idResponsavelFk: 'Id Responsavel Fk',
      idCargaFk: 'Id Carga Fk',
      idMotivoFk: 'Id Motivo Fk',
    },
    CsvAuditoria: {
      idAuditoriaPk: 'Id Auditoria Pk',
      auditoriaMotivo: 'Auditoria Motivo',
      carga: 'Carga',
      responsavel: 'Responsavel',
      conforme: 'Conforme',
      dataCriacao: 'Data Criacao',
      dataCanhoto: 'Data Canhoto',
      idResponsavelFk: 'Id Responsavel Fk',
      idCargaFk: 'Id Carga Fk',
      idMotivoFk: 'Id Motivo Fk',
    },
    InputOcorrenciaTrackingResponsavel: {
      idOcorrenciaTrackingResponsavelPk: 'Id',
      idResponsavelFk: 'Id Responsavel',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      idOcorrenciaExterna: 'ID Externo',
      descricao: 'Descrição',
      ativo: 'Ativo',
    },
    XlsxOcorrenciaTrackingResp: {
      idOcorrenciaTrackingResponsavelPk: 'Id Ocorrencia',
      idResponsavelFk: 'Id Responsavel',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      idOcorrenciaExterna: 'Id Externo',
      descricao: 'Descrição',
      ativo: 'Ativo',
    },
    ListOcorrenciaTrackingResponsavel: {
      idOcorrenciaTrackingResponsavelPk: 'ID',
      idResponsavelFk: 'ID Responsavel',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      idOcorrenciaExterna: 'Codigo Ocorrência',
      descricao: 'Descrição',
      ativo: 'Ativo',
    },
    CsvOcorrenciaTrackingResp: {
      title: 'Ocorrencia Tracking Responsavel',
      titleTracking: 'Tracking Tamplate',
      idOcorrenciaTrackingResponsavelPk: 'ID',
      idResponsavelFk: 'ID Responsavel',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      idOcorrenciaExterna: 'Codigo Ocorrência',
      descricao: 'Descrição',
      ativo: 'Ativo',
    },
    InputMotoristaJornada: {
      horaInicio: 'Inicio',
      horaFim: 'Fim',
      rangeCepInicial: 'CEP Inicial',
      rangeCepFinal: 'CEP Final',
      segunda: 'Segunda',
      terca: 'Terça',
      quarta: 'Quarta',
      quinta: 'Quinta',
      sexta: 'Sexta',
      sabado: 'Sábado',
      domingo: 'Domingo',
      ativo: 'Ativo',
    },
    InputEsconderMotorista: {
      idEsconderMotoristaPk: 'Id Esconder Motorista Pk',
      responsavel: 'Responsavel',
      data: 'Data',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListEsconderMotorista: {
      idEsconderMotoristaPk: 'Id Esconder Motorista Pk',
      responsavel: 'Responsavel',
      data: 'Data',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvEsconderMotorista: {
      idEsconderMotoristaPk: 'Id Esconder Motorista Pk',
      responsavel: 'Responsavel',
      data: 'Data',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputRelatorioGeracao: {
      idRelatorioGeracaoPk: 'Id Relatorio Geracao Pk',
      responsavel: 'Responsavel',
      tipoRelatorio: 'Tipo Relatorio',
      dataCriacao: 'Data Criacao',
      urlDownload: 'Url Download',
      dataGeracaoRelatorio: 'Data Geracao Relatorio',
      idResponsavelFk: 'Id Responsavel Fk',
      idTipoRelatorioFk: 'Id Tipo Relatorio Fk',
    },
    ListRelatorioGeracao: {
      idRelatorioGeracaoPk: 'Id Relatorio Geracao Pk',
      responsavel: 'Responsavel',
      tipoRelatorio: 'Tipo Relatorio',
      dataCriacao: 'Data Criacao',
      urlDownload: 'Url Download',
      dataGeracaoRelatorio: 'Data Geracao Relatorio',
      idResponsavelFk: 'Id Responsavel Fk',
      idTipoRelatorioFk: 'Id Tipo Relatorio Fk',
    },
    CsvRelatorioGeracao: {
      idRelatorioGeracaoPk: 'Id Relatorio Geracao Pk',
      responsavel: 'Responsavel',
      tipoRelatorio: 'Tipo Relatorio',
      dataCriacao: 'Data Criacao',
      urlDownload: 'Url Download',
      dataGeracaoRelatorio: 'Data Geracao Relatorio',
      idResponsavelFk: 'Id Responsavel Fk',
      idTipoRelatorioFk: 'Id Tipo Relatorio Fk',
    },
    InputCompartilhamentoApp: {
      idCompartilhamentoAppPk: 'Id Compartilhamento App Pk',
      motorista: 'Motorista',
      qtdCompartilhamento: 'Qtd Compartilhamento',
      idMotoristaFk: 'Id Motorista Fk',
    },
    ListCompartilhamentoApp: {
      idCompartilhamentoAppPk: 'Id Compartilhamento App Pk',
      motorista: 'Motorista',
      qtdCompartilhamento: 'Qtd Compartilhamento',
      idMotoristaFk: 'Id Motorista Fk',
    },
    CsvCompartilhamentoApp: {
      idCompartilhamentoAppPk: 'Id Compartilhamento App Pk',
      motorista: 'Motorista',
      qtdCompartilhamento: 'Qtd Compartilhamento',
      idMotoristaFk: 'Id Motorista Fk',
    },
    InputResponsavel: {
      idResponsavelPk: 'Id Responsavel Pk',
      endereco: 'Endereco',
      responsavelFilial: 'Responsavel Filial',
      responsavelResponsavel: 'Responsavel Responsavel',
      servoIndependente: 'Servo Independente',
      cnpj: 'CNPJ',
      maxResponsaveis: 'Max Responsaveis',
      jaRedefiniuSenha: 'Ja Redefiniu Senha',
      dataCriacao: 'Data Criacao',
      criadoPeloAdmin: 'Criado Pelo Admin',
      ativo: 'Ativo',
      permitirAssociado: 'Permitir cadastro de empresa associada',
      permitirSerialNumber: 'Permitir cadastro via número de série',
      receberNotificacoesCarga: 'Receber Notificacoes Carga',
      receberNotificacoesTrajeto: 'Receber Notificacoes Trajeto',
      auditoriaCepCheckInEmMetros: 'Auditoria Cep Check In Em Metros',
      auditoriaCepEntregaEmMetros: 'Auditoria Cep Entrega Em Metros',
      limitarConsulta16Dias: 'Limitar a consulta por 16 dias',
      permitirDtEmissaoCalcSla: 'Permitir data de emissão para calculo do SLA',
      limitarConsulta: 'Limitar a consulta por mês',
      versaoLight: 'Versão Light',
      permitirUsarCombo: 'Permitir Utilizar o Combo Opcional',
      permitirUsarPesquisa: 'Permitir Pesquisa de Satisfação',
      permitirFotoSilenciosa: 'Permitir Foto Silenciosa',
      permitirTransbordo: 'Permitir Transbordo',
      exibirConsultaPublica: 'Exibir na Consulta Pública (Kade)',
      liberarApi: 'Liberar Api',
      permitirSacPublico: 'Permitir Sac Publico',
      permitirCentroCusto: 'Permitir Centro de Custo',
      urlLogoEmpresa: 'Url Logo Empresa',
      razaoSocial: 'Razão Social',
      nomeFantasia: 'Nome Fantasia',
      nomeContato: 'Contato',
      dominiosAutorizados: 'Domínios de e-mail autorizados',
      telefone: 'Telefone',
      email: 'Email',
      senhaVisualizador: 'Senha apenas de Visualização',
      senhaAdmin: 'Senha Admin',
      senhaSac: 'Senha Sac',
      idResponsavelFiltroFilialFk: 'Id Responsavel Filtro Filial Fk',
      urlImgCabecalho: 'Url Img Cabecalho',
      urlImgRodape: 'Url Img Rodape',
      nomeSaraivaFtp: 'Nome Saraiva Ftp',
      ip: 'Ip',
      perguntaPesquisaSatisfacao: 'Pergunta Pesquisa Satisfacao',
      perguntaPesquisaSatisfacao2: 'Pergunta Pesquisa Satisfacao 2',
      senhaGrupoEconomico: 'Senha Grupo Economico',
      senhaIntegracao: 'Senha apenas de Integração',
      dataVencimento: 'Data de Vencimento',
      permitirRastreamentoDistancia: 'Permitir distância/tempo/mapa',
      senha: 'Senha do Responsável',
      idEnderecoFk: 'Id Endereco Fk',
      idFilialFk: 'Id Filial Fk',
      nomeResponsavelCadastroUltimaModificacao:
        'Responsável pelo Cadastro/Última modificação',
      habilitarBI: 'Habilitar Link BI',
      linkBI: 'Link do BI',
      permitirOutroDocumento: 'Permitir Outro Documento',
      permitirSms: 'Permitir SMS',
      apiSomenteGoogle: 'Somente API Google',
      linkSacPublico: 'Utilizar link SAC Público',
      exibirPrevisaoEntregaSacPublico:
        'Exibir previsão de entrega link SAC público',
      permitirLigacaoVoip: 'Permitir ligação VOIP Destinatário',
      permitirLigacaoVoipTorreControle:
        'Permitir ligação VOIP Torre de Controle',
      permitirWhatsapp: 'Permitir WhatsApp',
      obrigarAssinatura: 'Permitir Assinatura',
      permitirChecklist: 'Permitir Checklist Atendimento',
      permitirChecklistComponente: 'Permitir Checklist Componente',
      permitirRoterizacao: 'Permitir Roterização',
      retornarDistanciaTempoIntegracao:
        'Retornar Distância e Tempo na Integração',
      emitenteTransportador: 'Utilizar tomador como origem transporte?',
      webhookOcorrenciaM1: 'Ativar Webhook Ocorrência + Baixa M1',
      permitirDevolverNota:
        'Permitir Devolver Notas Iniciadas Para Não Iniciadas',
      permitirDevolverNotaFinalizadaParaNaoIniciada:
        'Permitir devolver notas finalizadas para pendente',
      clienteConcreto: 'Cliente concreto',
      permitirFotoInicioCarga: 'Permitir foto no início da carga',
      envioDeContraSenhaCpf: 'Envio de Contra Senha Cpf',
      envioDeContraSenhaCnpj: 'Envio de Contra Senha Cnpj',
      exportacao: 'Exportação',
      exibirConsultaKade: 'Exibir DANFE consulta KADE',
      permitirFinalizarSemFoto: 'Permitir finalizar ocorrência sem foto',
      obrigatoriedadeRecebedor: 'Tirar a obrigatoriedade do recebedor',
      tipoFinalizacaoSucesso: 'Tipo de finalização com sucesso',
      integracaoCorreios: 'Integração Correios',
      permitirAlertaNotaAtraso: 'Alerta nota em atraso',
      exibirMapaTelaSacPrivado: 'Exibir mapa tela SAC painel responsável',
      permitirDataReal: 'Permitir Data Real',
      urlWebhookAutenticacaoM1: 'Webhook Login M1',
      urlWebhookIntegracaoM1: 'Webhook Integração M1',
      loginWebhookM1: 'Login Webhook M1',
      keyWebhookM1: 'Key Webhook M1',
      senhaWebhookM1: 'Senha Webhook M1',
      senhaDevolverNota: 'Senha devolver notas para não iniciadas',
      repeatSenhaDevolverNota:
        'Digite novamente a Senha devolver notas para não iniciadas',
      permitirExcluirNotasFinalizadas: 'Permitir excluir notas finalizadas',
      senhaExcluirNotasFinalizadas: 'Senha para excluir notas finalizadas',
      repeatExcluirNotasFinalizadas:
        'Digite novamente a Senha para excluir notas finalizadas',
      repeatSenhaDevolverNotaFinalizadaParaNaoIniciada:
        'Digite novamente a Senha devolver notas finalizadas para não iniciadas',
      senhaDevolverNotaFinalizadaParaNaoIniciada:
        'Senha devolver notas finalizadas para não iniciadas',
      loginPorDocumento: 'Login por documento',
      outroDocumento: 'Outro Documento',
      nomeLogin: 'Nome do login no sistema',
      emailLogin: 'Email de login',
      raioCheckinAutomatico: 'Raio Check-In Automático em metros',
      integracaoTMS: 'TMS',
      acessoIlimitadoTransportadores: 'Acesso Ilimitado Transportadores',
      usaIntegracao: 'Usa integração',
      clientePossuiTorreDeControle: 'Cliente Possui Torre de Controle',
      nomeResponsavelTorreDeControle: 'Responsável Torre de Controle',
      permitirCheckinAutomatico: 'Permitir Check-In Automático',
      repeatSenhaResponsavel: 'Digite Novamente a Senha do Responsável',
      repeatSenhaVisualizador: 'Digite Novamente a Senha de Visualização',
      repeatSenhaIntegracao: 'Digite Novamente a Senha de Integração',
      liberarAPI: 'Liberar API',
      cpfCnpj: 'CNPJ/CPF',
      otherDocument: 'Outro documento',
      dataUltimaModificacao: 'Data Última Modificação',
      tipoDeDocumento: 'Tipo de Documento',
      parceiroNome: 'Nome do Cliente',
      logoEmpresa: 'Logo da Empresa',
      noImage: 'Sem Imagem',
      editPassword: 'Criar/Editar Senhas',
      liberacaoAcesso: 'Liberar Acesso',
      dadosUsuario: 'Dados Usuário',
      visualizacaoDePainel: 'Visualização no Painel',
      tipoDeCliente: 'Tipo de Cliente',
      tipoDeResponsavel: 'Tipo de Responsável',
      permitirCadastrarMesmaDanfe: 'Permitir cadastrar mesma DANFE',
      apiPublica: 'API pública de Geolocalização',
      visualizacaoCnpjFilial: 'Acesso a Todos os CNPJs',
      bloquearCriacaoNotaViaApp: 'Bloquear criação de nota via Aplicativo',
      bloquearCadastrarMesmaDanfe: 'Bloquear cadastrar mesma DANFE',
      permitirIniciarEntregaDepoisFinalizarAnterior:
        'Permitir iniciar entrega após finalizar a anterior',
      slaHoras: 'Permitir SLA por horas',
      associarEntregaEntregador: 'Associar entrega ao entregador',
      editarEntrega: 'Editar entrega',
      finalizarEntrega: 'Finalizar entrega',
      excluirEntrega: 'Excluir entrega',
      alterarCriarTipoOcorrencia: 'Alterar tipo de ocorrência',
      alterarConfig: 'Alterar configurações',
    },
    ListResponsavel: {
      idResponsavelPk: 'ID',
      endereco: 'Endereco',
      responsavelFilial: 'Responsavel Filial',
      responsavelResponsavel: 'Responsavel Responsavel',
      servoIndependente: 'Servo Independente',
      cnpj: 'CNPJ',
      maxResponsaveis: 'Max Responsaveis',
      jaRedefiniuSenha: 'Ja Redefiniu Senha',
      dataCriacao: 'Data Criacao',
      criadoPeloAdmin: 'Criado Pelo Admin',
      ativo: 'Ativo',
      permitirAssociado: 'Permitir Associado',
      permitirSerialNumber: 'Permitir Serial Number',
      receberNotificacoesCarga: 'Receber Notificacoes Carga',
      receberNotificacoesTrajeto: 'Receber Notificacoes Trajeto',
      auditoriaCepCheckInEmMetros: 'Auditoria Cep Check In Em Metros',
      auditoriaCepEntregaEmMetros: 'Auditoria Cep Entrega Em Metros',
      limitarConsulta: 'Limitar Consulta',
      versaoLight: 'Versao Light',
      permitirUsarCombo: 'Permitir Usar Combo',
      permitirUsarPesquisa: 'Permitir Usar Pesquisa',
      permitirFotoSilenciosa: 'Permitir Foto Silenciosa',
      permitirTransbordo: 'Permitir Transbordo',
      exibirConsultaPublica: 'Exibir Consulta Publica',
      liberarApi: 'Liberar Api',
      permitirSacPublico: 'Permitir Sac Publico',
      permitirCentroCusto: 'Permitir Centro Custo',
      urlLogoEmpresa: 'Possui Logo',
      razaoSocial: 'Razão Social',
      nomeFantasia: 'Nome Fantasia',
      nomeContato: 'Contato',
      telefone: 'Telefone',
      email: 'Email',
      senhaVisualizador: 'Senha Visualizador',
      senhaAdmin: 'Senha Admin',
      senhaSac: 'Senha Sac',
      idResponsavelFiltroFilialFk: 'Id Responsavel Filtro Filial Fk',
      urlImgCabecalho: 'Url Img Cabecalho',
      urlImgRodape: 'Url Img Rodape',
      nomeSaraivaFtp: 'Nome Saraiva Ftp',
      ip: 'Ip',
      perguntaPesquisaSatisfacao: 'Pergunta Pesquisa Satisfacao',
      perguntaPesquisaSatisfacao2: 'Pergunta Pesquisa Satisfacao 2',
      senhaGrupoEconomico: 'Senha Grupo Economico',
      senhaIntegracao: 'Senha Integracao',
      dataVencimento: 'Data de Vencimento',
      permitirRastreamentoDistancia: 'Permitir Rastreamento Distancia',
      senha: 'Senha',
      idEnderecoFk: 'Id Endereco Fk',
      idFilialFk: 'Id Filial Fk',
      tipoCriador: 'Cadastrado Por',
      admin: 'Admin',
      motorista: 'Motorista',
      responsavel: 'Responsável',
      slaHoras: 'SLA/Horas',
    },
    CsvResponsavel: {
      title: 'Responsáveis Brasil',
      idResponsavelPk: 'ID',
      endereco: 'Endereço',
      responsavelFilial: 'Responsavel Filial',
      responsavelResponsavel: 'Responsavel Responsavel',
      servoIndependente: 'Servo Independente',
      cnpj: 'CNPJ',
      maxResponsaveis: 'Max Responsaveis',
      jaRedefiniuSenha: 'Ja Redefiniu Senha',
      dataCriacao: 'Data Criação',
      criadoPeloAdmin: 'Criado Pelo Admin',
      ativo: 'Ativo',
      permitirAssociado: 'Permitir Associado',
      permitirSerialNumber: 'Permitir Serial Number',
      receberNotificacoesCarga: 'Receber Notificacoes Carga',
      receberNotificacoesTrajeto: 'Receber Notificacoes Trajeto',
      auditoriaCepCheckInEmMetros: 'Auditoria Cep Check In Em Metros',
      auditoriaCepEntregaEmMetros: 'Auditoria Cep Entrega Em Metros',
      limitarConsulta: 'Limitar Consulta',
      versaoLight: 'Versao Light',
      permitirUsarCombo: 'Permitir Usar Combo',
      permitirUsarPesquisa: 'Permitir Usar Pesquisa',
      permitirFotoSilenciosa: 'Permitir Foto Silenciosa',
      permitirTransbordo: 'Permitir Transbordo',
      exibirConsultaPublica: 'Exibir Consulta Publica',
      liberarApi: 'Cliente tem integração',
      permitirSacPublico: 'Permitir Sac Publico',
      permitirCentroCusto: 'Permitir Centro Custo',
      urlLogoEmpresa: 'Possui logo',
      razaoSocial: 'Razao Social',
      nomeFantasia: 'Nome Fantasia',
      nomeContato: 'Contato',
      telefone: 'Telefone',
      email: 'Email',
      senhaVisualizador: 'Senha Visualizador',
      senhaAdmin: 'Senha Admin',
      senhaSac: 'Senha Sac',
      idResponsavelFiltroFilialFk: 'Id Responsavel Filtro Filial Fk',
      urlImgCabecalho: 'Url Img Cabecalho',
      urlImgRodape: 'Url Img Rodape',
      nomeSaraivaFtp: 'Nome Saraiva Ftp',
      ip: 'Ip',
      perguntaPesquisaSatisfacao: 'Pergunta Pesquisa Satisfacao',
      perguntaPesquisaSatisfacao2: 'Pergunta Pesquisa Satisfacao 2',
      senhaGrupoEconomico: 'Senha Grupo Economico',
      senhaIntegracao: 'Senha Integracao',
      dataVencimento: 'Data de Vencimento',
      permitirRastreamentoDistancia: 'Permitir Rastreamento Distancia',
      senha: 'Senha',
      idEnderecoFk: 'Id Endereco Fk',
      idFilialFk: 'Id Filial Fk',
      tipoCriador: 'Tipo Cadastro',
      idQuemCadastrou: 'ID Quem cadastrou',
      quemCadastrou: 'Quem cadastrou',
      clienteBloqueado: 'Cliente está bloqueado',
      tipoCliente: 'Tipo de Cliente',
      usaGrupoEconomico: 'Cliente tem grupo econômico',
      usaIntegracao: 'Usa integração',
      integracaoTMS: 'TMS',
      acessoIlimitadoTransportadores: 'Acesso Ilimitado Transportadores',
      clientePossuiTorreDeControle: 'Cliente Possui Torre de Controle',
      nomeResponsavelTorreDeControle: 'Responsavel Torre de Controle',
      nomeResponsavelCadastroUltimaModificacao:
        'Responsável Cadastro/Última Modificação',
      dataUltimaModificacao: 'Data Última Modificação',
      temGrupoParceiro: 'Grupo Parceiro',
      tipoClienteParceiroNome: 'Nome do Cliente',
      cliente: 'Cliente',
      visualizacaoCnpjFilial: 'Acesso a Todos os CNPJs',
      associarEntregaEntregador: 'Associar entrega ao entregador',
      editarEntrega: 'Editar entrega',
      finalizarEntrega: 'Finalizar entrega',
      excluirEntrega: 'Excluir entrega',
      alterarCriarTipoOcorrencia: 'Alterar tipo de ocorrência',
      alterarConfig: 'Alterar configurações',
    },
    InputErroIntegracao: {
      idErroPk: 'Id Erro Pk',
      webserviceIntegracao: 'Webservice Integracao',
      responsavel: 'Responsavel',
      request: 'Request',
      response: 'Response',
      data: 'Data',
      danfe: 'Danfe',
      nf: 'Nf',
      idResponsavelFk: 'Id Responsavel Fk',
      idWebserviceFk: 'Id Webservice Fk',
    },
    ListErroIntegracao: {
      idErroPk: 'Id Erro Pk',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      nf: 'Nf',
      danfe: 'Danfe',
      response: 'Mensagem',
      quant: 'Quantidade',
      data: 'Última Data',
      idResponsavelFk: 'Id Responsavel Fk',
      idWebserviceFk: 'Id Webservice Fk',
    },
    CsvErroIntegracao: {
      idErroPk: 'Id Erro Pk',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      nf: 'Nf',
      danfe: 'Danfe',
      response: 'Mensagem',
      quant: 'Quantidade',
      data: 'Última Data',
      idResponsavelFk: 'Id Responsavel Fk',
      idWebserviceFk: 'Id Webservice Fk',
    },
    InputAlerta: {
      idAlertaPk: 'ID',
      descricao: 'Descrição',
      ativo: 'Ativo',
    },
    ListAlerta: {
      idAlertaPk: 'ID',
      descricao: 'Descrição',
      ativo: 'Ativo',
    },
    CsvAlerta: {
      idAlertaPk: 'Id Alerta Pk',
      descricao: 'Descrição',
      ativo: 'Ativo',
    },
    InputRastreamento: {
      idRastreamentoPk: 'Id Rastreamento Pk',
      responsavel: 'Responsavel',
      placa: 'Placa',
      codigoViagem: 'Codigo Viagem',
      latitude: 'Latitude',
      longitude: 'Longitude',
      dataUltimaPosicao: 'Data Ultima Posicao',
      endereco: 'Endereco',
      numeroParadas: 'Numero Paradas',
      codigoRastreioVeiculo: 'Codigo Rastreio Veiculo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListRastreamento: {
      idRastreamentoPk: 'Id Rastreamento Pk',
      responsavel: 'Responsavel',
      placa: 'Placa',
      codigoViagem: 'Codigo Viagem',
      latitude: 'Latitude',
      longitude: 'Longitude',
      dataUltimaPosicao: 'Data Ultima Posicao',
      endereco: 'Endereco',
      numeroParadas: 'Numero Paradas',
      codigoRastreioVeiculo: 'Codigo Rastreio Veiculo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvRastreamento: {
      idRastreamentoPk: 'Id Rastreamento Pk',
      responsavel: 'Responsavel',
      placa: 'Placa',
      codigoViagem: 'Codigo Viagem',
      latitude: 'Latitude',
      longitude: 'Longitude',
      dataUltimaPosicao: 'Data Ultima Posicao',
      endereco: 'Endereco',
      numeroParadas: 'Numero Paradas',
      codigoRastreioVeiculo: 'Codigo Rastreio Veiculo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputMotoristaResponsavel: {
      idMotoristaFk: 'Id Motorista Fk',
      idResponsavelFk: 'Id Responsavel Fk',
      motorista: 'Motorista',
      responsavel: 'Responsavel',
      apelido: 'Apelido',
    },
    ListMotoristaResponsavel: {
      idMotoristaFk: 'Id Motorista Fk',
      idResponsavelFk: 'Id Responsavel Fk',
      motorista: 'Motorista',
      responsavel: 'Responsavel',
      apelido: 'Apelido',
    },
    CsvMotoristaResponsavel: {
      idMotoristaFk: 'Id Motorista Fk',
      idResponsavelFk: 'Id Responsavel Fk',
      motorista: 'Motorista',
      responsavel: 'Responsavel',
      apelido: 'Apelido',
    },
    InputBaseFretebasEmpresa: {
      idFretebasPk: 'Id Fretebas Pk',
      empresa: 'Empresa',
      razaoSocial: 'Razao Social',
      ramo: 'Ramo',
      tipo: 'Tipo',
      endereco: 'Endereco',
      nextel: 'Nextel',
      celular: 'Celular',
      fone: 'Fone',
      whatsup: 'Whatsup',
      sac: 'Sac',
      response: 'Response',
    },
    ListBaseFretebasEmpresa: {
      idFretebasPk: 'Id Fretebas Pk',
      empresa: 'Empresa',
      razaoSocial: 'Razao Social',
      ramo: 'Ramo',
      tipo: 'Tipo',
      endereco: 'Endereco',
      nextel: 'Nextel',
      celular: 'Celular',
      fone: 'Fone',
      whatsup: 'Whatsup',
      sac: 'Sac',
      response: 'Response',
    },
    CsvBaseFretebasEmpresa: {
      idFretebasPk: 'Id Fretebas Pk',
      empresa: 'Empresa',
      razaoSocial: 'Razao Social',
      ramo: 'Ramo',
      tipo: 'Tipo',
      endereco: 'Endereco',
      nextel: 'Nextel',
      celular: 'Celular',
      fone: 'Fone',
      whatsup: 'Whatsup',
      sac: 'Sac',
      response: 'Response',
    },
    InputResponsavelGrupoEconomico: {
      idResponsavelMasterFk: 'Id Responsavel Master Fk',
      idResponsavelPermitidoFk: 'Id Responsavel Permitido Fk',
      responsavelMaster: 'Responsavel Master',
      responsavelPermitido: 'Responsavel Permitido',
      dataCriacao: 'Data Criacao',
      senha: 'Senha do Resp. Permitido',
      responsaveis: 'Selecione o responsável',
      noOptionsLabel: 'Lista vazia',
      noResultLabel: 'Nenhum Responsável encontrado',
    },
    ListResponsavelGrupoEconomico: {
      idResponsavelMasterFk: 'Id Responsavel Master Fk',
      idResponsavelPermitidoFk: 'Id Responsavel Permitido Fk',
      responsavelMaster: 'Responsavel Master',
      responsavelPermitido: 'Responsavel Permitido',
      dataCriacao: 'Data Criacao',
      senha: 'Senha',
    },
    CsvResponsavelGrupoEconomico: {
      idResponsavelMasterFk: 'Id Responsavel Master Fk',
      idResponsavelPermitidoFk: 'Id Responsavel Permitido Fk',
      responsavelMaster: 'Responsavel Master',
      responsavelPermitido: 'Responsavel Permitido',
      dataCriacao: 'Data Criacao',
      senha: 'Senha',
    },
    InputResponsavelGrupoParceiro: {
      idResponsavelMasterFk: 'Id Responsavel Master Fk',
      idResponsavelParceiroFk: 'Id Parceiro Permitido Fk',
      responsavelMaster: 'Responsavel Master',
      parceiroPermitido: 'Parceiro Permitido',
      parceiros: 'Selecione o parceiro',
      noOptionsLabel: 'Lista vazia',
      noResultLabel: 'Nenhum Responsável encontrado',
    },
    InputRastreamentoHistorico: {
      idRastreamentoHistoricoPk: 'Id Rastreamento Historico Pk',
      rastreamento: 'Rastreamento',
      latitude: 'Latitude',
      longitude: 'Longitude',
      dataPosicao: 'Data Posicao',
      statusCarga: 'Status Carga',
      idExterno: 'Id Externo',
      idRastreamentoFk: 'Id Rastreamento Fk',
    },
    ListRastreamentoHistorico: {
      idRastreamentoHistoricoPk: 'Id Rastreamento Historico Pk',
      rastreamento: 'Rastreamento',
      latitude: 'Latitude',
      longitude: 'Longitude',
      dataPosicao: 'Data Posicao',
      statusCarga: 'Status Carga',
      idExterno: 'Id Externo',
      idRastreamentoFk: 'Id Rastreamento Fk',
    },
    CsvRastreamentoHistorico: {
      idRastreamentoHistoricoPk: 'Id Rastreamento Historico Pk',
      rastreamento: 'Rastreamento',
      latitude: 'Latitude',
      longitude: 'Longitude',
      dataPosicao: 'Data Posicao',
      statusCarga: 'Status Carga',
      idExterno: 'Id Externo',
      idRastreamentoFk: 'Id Rastreamento Fk',
    },
    InputTypeSms: {
      idTypePk: 'Id Type Pk',
      ativo: 'Ativo',
      nome: 'Nome',
    },
    ListTypeSms: {
      idTypePk: 'Id Type Pk',
      ativo: 'Ativo',
      nome: 'Nome',
    },
    CsvTypeSms: {
      idTypePk: 'Id Type Pk',
      ativo: 'Ativo',
      nome: 'Nome',
    },
    InputAuditoriaMotivo: {
      idMotivoPk: 'Id Motivo Pk',
      responsavel: 'Responsavel',
      nome: 'Nome',
      ativo: 'Ativo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListAuditoriaMotivo: {
      idMotivoPk: 'ID',
      responsavel: 'Responsavel',
      nome: 'Nome',
      ativo: 'Ativo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvAuditoriaMotivo: {
      idMotivoPk: 'Id Motivo Pk',
      responsavel: 'Responsavel',
      nome: 'Nome',
      ativo: 'Ativo',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputPosicaoMotorista: {
      idPosicaoPk: 'Id Posicao Pk',
      carga: 'Carga',
      motorista: 'Motorista',
      latitude: 'Latitude',
      longitude: 'Longitude',
      data: 'Data',
      distanciaParaDestinoEmMetros: 'Distancia Para Destino Em Metros',
      duracaoParaDestinoEmSegundos: 'Duracao Para Destino Em Segundos',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
    },
    ListPosicaoMotorista: {
      idPosicaoPk: 'Id Posicao Pk',
      carga: 'Carga',
      motorista: 'Motorista',
      latitude: 'Latitude',
      longitude: 'Longitude',
      data: 'Data',
      distanciaParaDestinoEmMetros: 'Distancia Para Destino Em Metros',
      duracaoParaDestinoEmSegundos: 'Duracao Para Destino Em Segundos',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
    },
    CsvPosicaoMotorista: {
      idPosicaoPk: 'Id Posicao Pk',
      carga: 'Carga',
      motorista: 'Motorista',
      latitude: 'Latitude',
      longitude: 'Longitude',
      data: 'Data',
      distanciaParaDestinoEmMetros: 'Distancia Para Destino Em Metros',
      duracaoParaDestinoEmSegundos: 'Duracao Para Destino Em Segundos',
      idMotoristaFk: 'Id Motorista Fk',
      idCargaFk: 'Id Carga Fk',
    },
    InputCentroDeCusto: {
      idCentroDeCustoPk: 'Id Centro De Custo Pk',
      idResponsavelFk: 'Id Responsavel Fk',
      responsavel: 'Responsavel',
      cargaCentroDeCusto: 'Carga Centro De Custo',
      nome: 'Nome',
    },
    ListCentroDeCusto: {
      idCentroDeCustoPk: 'Id Centro De Custo Pk',
      idResponsavelFk: 'Id Responsavel Fk',
      responsavel: 'Responsavel',
      cargaCentroDeCusto: 'Carga Centro De Custo',
      nome: 'Nome',
    },
    CsvCentroDeCusto: {
      idCentroDeCustoPk: 'Id Centro De Custo Pk',
      idResponsavelFk: 'Id Responsavel Fk',
      responsavel: 'Responsavel',
      cargaCentroDeCusto: 'Carga Centro De Custo',
      nome: 'Nome',
    },
    InputMotoristaMensagemPush: {
      idMensagemPk: 'Id Mensagem Pk',
      motorista: 'Motorista',
      responsavel: 'Responsavel',
      mensagem: 'Mensagem',
      data: 'Data',
      ativo: 'Ativo',
      lida: 'Lida',
      idResponsavelFk: 'Id Responsavel Fk',
      idMotoristaFk: 'Id Motorista Fk',
    },
    ListMotoristaMensagemPush: {
      idMensagemPk: 'Id Mensagem Pk',
      motorista: 'Motorista',
      responsavel: 'Responsavel',
      mensagem: 'Mensagem',
      data: 'Data',
      ativo: 'Ativo',
      lida: 'Lida',
      idResponsavelFk: 'Id Responsavel Fk',
      idMotoristaFk: 'Id Motorista Fk',
    },
    CsvMotoristaMensagemPush: {
      idMensagemPk: 'Id Mensagem Pk',
      motorista: 'Motorista',
      responsavel: 'Responsavel',
      mensagem: 'Mensagem',
      data: 'Data',
      ativo: 'Ativo',
      lida: 'Lida',
      idResponsavelFk: 'Id Responsavel Fk',
      idMotoristaFk: 'Id Motorista Fk',
    },
    InputMascaraTransportadorSacPublico: {
      idMascaraTransportadorSacPublicoPk:
        'Id Mascara Transportador Sac Publico Pk',
      responsavel: 'Responsavel',
      ativo: 'Ativo',
      idResponsavelMascaraFk: 'Id Responsavel Mascara Fk',
    },
    ListMascaraTransportadorSacPublico: {
      idMascaraTransportadorSacPublicoPk:
        'Id Mascara Transportador Sac Publico Pk',
      responsavel: 'Responsavel',
      ativo: 'Ativo',
      idResponsavelMascaraFk: 'Id Responsavel Mascara Fk',
    },
    CsvMascaraTransportadorSacPublico: {
      idMascaraTransportadorSacPublicoPk:
        'Id Mascara Transportador Sac Publico Pk',
      responsavel: 'Responsavel',
      ativo: 'Ativo',
      idResponsavelMascaraFk: 'Id Responsavel Mascara Fk',
    },
    InputTipoOcorrencia: {
      idOcorrenciaPk: 'Id Ocorrencia Pk',
      responsavel: 'Responsavel',
      nome: 'Nome',
      ativo: 'Ativo',
      ehDevolvida: 'Para Cargas Devolvidas',
      idOcorrenciaExterna: 'Id Ocorrencia Externa',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListTipoOcorrencia: {
      idOcorrenciaPk: 'ID',
      responsavel: 'Responsavel',
      nome: 'Nome',
      ativo: 'Ativo',
      ehDevolvida: 'Para Cargas Devolvidas',
      idOcorrenciaExterna: 'Id Ocorrencia Externa',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvTipoOcorrencia: {
      title: 'Tipo Ocorrência',
      idOcorrenciaPk: 'ID',
      responsavel: 'Responsavel',
      nome: 'Nome',
      ativo: 'Ativo',
      ehDevolvida: 'Para Cargas Devolvidas',
      idOcorrenciaExterna: 'Id Ocorrencia Externa',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputResponseRobo: {
      idResponsePk: 'Id Response Pk',
      danfe: 'Danfe',
      response: 'Response',
      ehCte: 'Eh Cte',
    },
    ListResponseRobo: {
      idResponsePk: 'Id Response Pk',
      danfe: 'Danfe',
      response: 'Response',
      ehCte: 'Eh Cte',
    },
    CsvResponseRobo: {
      idResponsePk: 'Id Response Pk',
      danfe: 'Danfe',
      response: 'Response',
      ehCte: 'Eh Cte',
    },
    InputPontaSla: {
      idPontaSlaPk: 'Id Ponta Sla Pk',
      abreviacao: 'Abreviacao',
      uf: 'Uf',
      naCapital: 'Na Capital',
      cidade: 'Cidade',
    },
    ListPontaSla: {
      idPontaSlaPk: 'Id Ponta Sla Pk',
      abreviacao: 'Abreviacao',
      uf: 'Uf',
      naCapital: 'Na Capital',
      cidade: 'Cidade',
    },
    CsvPontaSla: {
      idPontaSlaPk: 'Id Ponta Sla Pk',
      abreviacao: 'Abreviacao',
      uf: 'Uf',
      naCapital: 'Na Capital',
      cidade: 'Cidade',
    },
    InputReponsavelAssociado: {
      idAssociadoPk: 'Id Associado Pk',
      responsavel: 'Responsavel',
      razaoSocial: 'Razao Social',
      nomeFantasia: 'Nome Fantasia',
      cnpj: 'Cnpj',
      ativo: 'Ativo',
      senha: 'Senha',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListReponsavelAssociado: {
      idAssociadoPk: 'Id Associado Pk',
      responsavel: 'Responsavel',
      razaoSocial: 'Razao Social',
      nomeFantasia: 'Nome Fantasia',
      cnpj: 'Cnpj',
      ativo: 'Ativo',
      senha: 'Senha',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvReponsavelAssociado: {
      idAssociadoPk: 'Id Associado Pk',
      responsavel: 'Responsavel',
      razaoSocial: 'Razao Social',
      nomeFantasia: 'Nome Fantasia',
      cnpj: 'Cnpj',
      ativo: 'Ativo',
      senha: 'Senha',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputResponsavelFilial: {
      idFilialPk: 'Id Filial Pk',
      cnpjBase: 'Cnpj Base',
    },
    ListResponsavelFilial: {
      idFilialPk: 'Id Filial Pk',
      cnpjBase: 'Cnpj Base',
    },
    CsvResponsavelFilial: {
      idFilialPk: 'Id Filial Pk',
      cnpjBase: 'Cnpj Base',
    },
    InputResponsavelSaraiva: {
      idResponsavelSaraivaPk: 'Id Responsavel Saraiva Pk',
      responsavel: 'Responsavel',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    ListResponsavelSaraiva: {
      idResponsavelSaraivaPk: 'Id Responsavel Saraiva Pk',
      responsavel: 'Responsavel',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    CsvResponsavelSaraiva: {
      idResponsavelSaraivaPk: 'Id Responsavel Saraiva Pk',
      responsavel: 'Responsavel',
      idResponsavelFk: 'Id Responsavel Fk',
    },
    InputParametroRelatorio: {
      idParametroRelatorioPk: 'Id Parametro Relatorio Pk',
      relatorioGeracao: 'Relatorio Geracao',
      dateBy: 'Date By',
      cnpjDestinatario: 'Cnpj Destinatario',
      cnpjEmbarcadorTransportador: 'Cnpj Embarcador Transportador',
      nroFiscal: 'Nro Fiscal',
      ocorrencia: 'Ocorrencia',
      auditoria: 'Auditoria',
      comMotorista: 'Com Motorista',
      idMotorista: 'Id Motorista',
      idStatus: 'Id Status',
      slaPendente: 'Sla Pendente',
      cep: 'Cep',
      uf: 'Uf',
      cidade: 'Cidade',
      cte: 'Cte',
      idOcorrencia: 'Id Ocorrencia',
      start: 'Start',
      end: 'End',
      idRelatorioGeracaoFk: 'Id Relatorio Geracao Fk',
    },
    ListParametroRelatorio: {
      idParametroRelatorioPk: 'Id Parametro Relatorio Pk',
      relatorioGeracao: 'Relatorio Geracao',
      dateBy: 'Date By',
      cnpjDestinatario: 'Cnpj Destinatario',
      cnpjEmbarcadorTransportador: 'Cnpj Embarcador Transportador',
      nroFiscal: 'Nro Fiscal',
      ocorrencia: 'Ocorrencia',
      auditoria: 'Auditoria',
      comMotorista: 'Com Motorista',
      idMotorista: 'Id Motorista',
      idStatus: 'Id Status',
      slaPendente: 'Sla Pendente',
      cep: 'Cep',
      uf: 'Uf',
      cidade: 'Cidade',
      cte: 'Cte',
      idOcorrencia: 'Id Ocorrencia',
      start: 'Start',
      end: 'End',
      idRelatorioGeracaoFk: 'Id Relatorio Geracao Fk',
    },
    CsvParametroRelatorio: {
      idParametroRelatorioPk: 'Id Parametro Relatorio Pk',
      relatorioGeracao: 'Relatorio Geracao',
      dateBy: 'Date By',
      cnpjDestinatario: 'Cnpj Destinatario',
      cnpjEmbarcadorTransportador: 'Cnpj Embarcador Transportador',
      nroFiscal: 'Nro Fiscal',
      ocorrencia: 'Ocorrencia',
      auditoria: 'Auditoria',
      comMotorista: 'Com Motorista',
      idMotorista: 'Id Motorista',
      idStatus: 'Id Status',
      slaPendente: 'Sla Pendente',
      cep: 'Cep',
      uf: 'Uf',
      cidade: 'Cidade',
      cte: 'Cte',
      idOcorrencia: 'Id Ocorrencia',
      start: 'Start',
      end: 'End',
      idRelatorioGeracaoFk: 'Id Relatorio Geracao Fk',
    },
    InputStatusSms: {
      idStatusPk: 'Id Status Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    ListStatusSms: {
      idStatusPk: 'Id Status Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    CsvStatusSms: {
      idStatusPk: 'Id Status Pk',
      nome: 'Nome',
      ativo: 'Ativo',
    },
    InputBaseFretebas: {
      idFretebasPk: 'Id Fretebas Pk',
      carga: 'Carga',
      preco: 'Preco',
      veiculos: 'Veiculos',
      carroceria: 'Carroceria',
      km: 'Km',
      especie: 'Especie',
      complemento: 'Complemento',
      rastreamento: 'Rastreamento',
      obs: 'Obs',
      nextel: 'Nextel',
      celular: 'Celular',
      fone: 'Fone',
      whatsup: 'Whatsup',
      sac: 'Sac',
      nome: 'Nome',
      origem: 'Origem',
      destino: 'Destino',
      response: 'Response',
    },
    ListBaseFretebas: {
      idFretebasPk: 'Id Fretebas Pk',
      carga: 'Carga',
      preco: 'Preco',
      veiculos: 'Veiculos',
      carroceria: 'Carroceria',
      km: 'Km',
      especie: 'Especie',
      complemento: 'Complemento',
      rastreamento: 'Rastreamento',
      obs: 'Obs',
      nextel: 'Nextel',
      celular: 'Celular',
      fone: 'Fone',
      whatsup: 'Whatsup',
      sac: 'Sac',
      nome: 'Nome',
      origem: 'Origem',
      destino: 'Destino',
      response: 'Response',
    },
    CsvBaseFretebas: {
      idFretebasPk: 'Id Fretebas Pk',
      carga: 'Carga',
      preco: 'Preco',
      veiculos: 'Veiculos',
      carroceria: 'Carroceria',
      km: 'Km',
      especie: 'Especie',
      complemento: 'Complemento',
      rastreamento: 'Rastreamento',
      obs: 'Obs',
      nextel: 'Nextel',
      celular: 'Celular',
      fone: 'Fone',
      whatsup: 'Whatsup',
      sac: 'Sac',
      nome: 'Nome',
      origem: 'Origem',
      destino: 'Destino',
      response: 'Response',
    },
    InputSaraivaCnpjDisponivel: {
      id: 'Id',
      cnpjRaiz: 'Cnpj Raiz',
    },
    ListSaraivaCnpjDisponivel: {
      id: 'Id',
      cnpjRaiz: 'Cnpj Raiz',
    },
    CsvSaraivaCnpjDisponivel: {
      id: 'Id',
      cnpjRaiz: 'Cnpj Raiz',
    },
    InputEndereco: {
      idEnderecoPk: 'Id Endereco Pk',
      logradouro: 'Logradouro',
      cidade: 'Cidade',
      uf: 'UF',
      nro: 'Número',
      bairro: 'Bairro',
      cep: 'CEP',
      latitude: 'Latitude',
      longitude: 'Longitude',
      pais: 'País',
      complemento: 'Complemento',
    },
    ListEndereco: {
      idEnderecoPk: 'Id Endereco Pk',
      logradouro: 'Logradouro',
      cidade: 'Cidade',
      uf: 'Uf',
      nro: 'Nro',
      bairro: 'Bairro',
      cep: 'Cep',
      latitude: 'Latitude',
      longitude: 'Longitude',
    },
    CsvEndereco: {
      idEnderecoPk: 'Id Endereco Pk',
      logradouro: 'Logradouro',
      cidade: 'Cidade',
      uf: 'Uf',
      nro: 'Nro',
      bairro: 'Bairro',
      cep: 'Cep',
      latitude: 'Latitude',
      longitude: 'Longitude',
    },
    InputCargaOpenlog: {
      idCodigoPk: 'Id Codigo Pk',
      carga: 'Carga',
      idPedido: 'Id Pedido',
      idCargaFk: 'Id Carga Fk',
    },
    ListCargaOpenlog: {
      idCodigoPk: 'Id Codigo Pk',
      carga: 'Carga',
      idPedido: 'Id Pedido',
      idCargaFk: 'Id Carga Fk',
    },
    CsvCargaOpenlog: {
      idCodigoPk: 'Id Codigo Pk',
      carga: 'Carga',
      idPedido: 'Id Pedido',
      idCargaFk: 'Id Carga Fk',
    },
    ErroIntegracaoFilter: {
      start: 'Data de início',
      end: 'Data de fim',
      responsavel: 'Responsável',
      nroFiscal: 'Consulta por nota fiscal',
    },
    FaturamentoFilter: {
      diaInicial: 'Dia Inicial',
      diaFinal: 'Dia Final',
      cnpj: 'CNPJ',
      mesAsResource: 'Mês',
      anoAsResource: 'Ano',
    },
    DashboardFilter: {
      anoAsResource: 'Ano',
      mes: 'Mês',
    },
    ListDashboard: {
      indicadores: 'Indicadores',
      qtdEntregadores: 'Entregadores',
      qtdNotasInseridasApp: 'Notas Inseridas no App',
      qtdNotasInseridasPainel: 'Notas Inseridas no Painel',
      qtdNotasInseridasIntegracao: 'Notas Inseridas na Integração',
      qtdNotasFinalizadasApp: 'Notas Finalizadas no App',
      qtdNotasFinalizadasPainel: 'Notas Finalizadas no Painel',
      qtdNotasFinalizadasIntegracao: 'Notas Finalizadas na Integração',
      qtdNotasCanceladas: 'Notas Canceladas',
      qtdSmsDisparado: 'Sms Disparados',
      qtdEmailDisparado: 'Emails Disparados',
      qtdAcessoPortalCliente: 'Acessos do Portal Cliente',
      qtdConsultasRoveriNota: 'Consultas Roveri Notas',
      qtdConsultasRoveriCnpj: 'Consultas Roveri CNPJ',
      lastUpdate: 'Última atualização: ',
      totalNotasInseridas: 'Total Notas Inseridas',
      totalNotasFinalizadas: 'Total Notas Finalizadas',
      qtdResponsaveis: 'Responsáveis',
      qtdResponsaveisUltimos30Dias:
        'Responsáveis que operaram nos últimos 30 dias',
      total: 'Total',
    },
    InputRelatorioAutomatico: {
      responsavel: 'Responsável',
      periodoInicial: 'Período data de início (Criação da carga)',
      pastaFTP: 'Pasta FTP',
      senhaFTP: 'Senha FTP',
      ativo: 'Ativo',
      idResponsavelFk: 'ID Responsavel',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      nomeFantasia: 'Nome Fantasia',
      warning: 'Responsável não configurado',
      success: 'Responsável configurado com sucesso',
      noResultLabel: 'Nenhum Responsável encontrado',
      noOptionsLabel: 'Lista vazia',
    },
    InputRelatorioEntrega: {
      responsavel: 'Responsável',
      periodoInicial: 'Data início relatório',
      periodoFinal: 'Data fim relatório',
      idResponsavelFk: 'ID Responsavel',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      nomeFantasia: 'Nome Fantasia',
      warning: 'Responsável não selecionado',
      success: 'Relatório gerado com sucesso',
      warningDateRange:
        'Intervalo entre as datas não pode ser superior a 30 dias',
      initDateRequired: 'Data Inicial é obrigatória',
      noResultLabel: 'Nenhum Responsável encontrado',
      noOptionsLabel: 'Lista vazia',
    },
    InputExportarRelatorioFaturamento: {
      dataInicial: 'Data inicial',
      dataFinal: 'Data Final',
      ehGrupoEconomico: 'Grupo Econômico',
    },
    InputNotasInseridasConfiguracao: {
      responsavel: 'Responsável',
      ehGrupoEconomico: 'Grupo Econômico',
      ativo: 'Ativo',
      idResponsavelFk: 'ID Responsavel',
      cnpj: 'CNPJ',
      razaoSocial: 'Razão Social',
      nomeFantasia: 'Nome Fantasia',
      success: 'Responsável configurado com sucesso',
      noResultLabel: 'Nenhum Responsável encontrado',
      noOptionsLabel: 'Lista vazia',
    },
    NotasInseridasFilter: {
      mesAsResource: 'Mês',
      anoAsResource: 'Ano',
    },
    CsvNotasInseridas: {
      title: 'Notas Inseridas',
      titleCsvMensal: 'Notas Inseridas Mensal',
      titleCsvSemanal: 'Notas Inseridas Semanal',
      nomeFantasia: 'Nome Fantasia',
      janeiro: 'Janeiro',
      fevereiro: 'Fevereiro',
      marco: 'Março',
      abril: 'abril',
      maio: 'Maio',
      junho: 'Junho',
      julho: 'Julho',
      agosto: 'Agosto',
      setembro: 'Setembro',
      outubro: 'Outubro',
      novembro: 'Novembro',
      dezembro: 'Dezembro',
      semana1: 'Semana 1',
      semana2: 'Semana 2',
      semana3: 'Semana 3',
      semana4: 'Semana 4',
      semana5: 'Semana 5',
    },
    ListPanelUser: {
      id: 'ID',
      document: 'Documento',
      corporateName: 'Razão Social',
      contactName: 'Contato',
      telephone: 'Telefone',
      dueDate: 'Data de Vencimento',
      userType: 'Tipo de Responsável',
      createdByAdm: 'Cadastrado Por',
      email: 'Email',
    },
    InputPanelUser: {
      document: 'Documento',
      corporateName: 'Razão Social',
      contactName: 'Contato',
      email: 'E-mail',
      telephone: 'Telefone',
      dueDate: 'Data de Vencimento',
      integrationEnabled: 'Usa integração',
      hasControlTower: 'Cliente possui Torre de Controle',
      limitedTransporterAccess: 'Acesso ilimitado Transportadores',
      limitMonthlyQueries: 'Limitar a consulta por mês',
      apiEnabled: 'Liberar API',
      permissionForSacPublic: 'Exibir na Consulta Pública (Kade)',
      password: 'Senha do Responsável',
      repeatPassword: 'Digite Novamente a Senha do Responsável',
      inputVisualizationMode: 'Editar Grupo Visualizador',
      visualizationMode: 'Grupo Visualizador',
    },
    InputAddress: {
      street: 'Logradouro',
      number: 'Número',
      city: 'Cidade',
      state: 'Estado',
      zipcode: 'Zipcode',
      neighborhood: 'Bairro',
    },
    ExportPanelUser: {
      title: 'Responsáveis Exterior',
      idPanelUserPk: 'ID',
      document: 'Documento',
      corporateName: 'Razão Social',
      contactName: 'Contato',
      email: 'E-mail',
      telephone: 'Telefone',
      dueDate: 'Data de Vencimento',
      integrationEnabled: 'Usa integração',
      hasControlTower: 'Cliente possui Torre de Controle',
      limitedTransporterAccess: 'Acesso ilimitado Transportadores',
      limitMonthlyQueries: 'Limitar a consulta por mês',
      apiEnabled: 'Liberar API',
      active: 'Cliente está bloqueado',
      address: 'Endereço',
      tms: 'TMS',
      unlimitedTransporterAccess: 'Acesso Ilimitado Transportadores',
      createdByAdm: 'Cadastrado Por',
      panelUserType: 'Tipo de Cliente',
      lastUpdate: 'Data Última Modificação',
      creationDate: 'Data Criação',
      partnerName: 'Nome do Cliente',
      towerControlManagerName: 'Responsável Torre de Controle',
      idUserTypeFk: 'Tipo de Responsável',
      registrantId: 'ID Quem cadastrou',
      registrantName: 'Quem cadastrou',
    },
    UserType: {
      shipper: 'Embarcador',
      transporter: 'Transportador',
      hybrid: 'Híbrido',
    },
    PanelUserType: {
      customer: 'Cliente',
      partner: 'Parceiro',
    },
    ListVisualizationMode: {
      idVisualizationModePk: 'Grupo Visualizador',
      description: 'Descrição',
    },
    InputVisualizationMode: {
      idVisualizationModePk: 'Grupo Visualizador',
      description: 'Descrição',
      responsaveisPermitidos: 'Responsáveis Permitidos',
      responsavelPermitido: 'Responsável Permitido',
      noResultLabel: 'Nenhum Responsável encontrado',
      noOptionsLabel: 'Lista vazia',
    },
    InputResponsavelUsuario: {
      nome: 'Nome',
      email: 'E-mail',
      senha: 'Senha Temporária',
      tipoResponsavelUsuarioAsResource: 'Tipo do Usuário',
      permitirCadastrarUsuario: 'Permitir Cadastrar Usuários',
      ativo: 'Ativo',
    },
    ListResponsavelUsuario: {
      idResponsavelUsuarioPk: 'ID',
      nome: 'Nome',
      email: 'E-mail',
      tipoResponsavelUsuario: 'Tipo do Usuário',
      ativo: 'Ativo',
    },
    CsvResponsavelUsuario: {
      title: 'Usuários',
      idResponsavelUsuarioPk: 'ID',
      nome: 'Nome',
      email: 'E-mail',
      tipoResponsavelUsuario: 'Tipo do Usuário',
      permitirCadastrarUsuario: 'Permitir Cadastrar Usuários',
      ativo: 'Ativo',
      ehSenhaTemporaria: 'Senha Temporária',
    },
  },

  components: {
    PopoverResponsavel: {
      editResponsavel: 'Alterar Responsável',
      editExpirationDate: 'Alterar Data de Vencimento',
      blockAccess: 'Bloquear Acesso',
      allowAccess: 'Permitir Acesso',
      grupoEconomico: 'Grupo Econômico',
      grupoParceiro: 'Grupo Parceiro',
      editRespUser: 'Cadastro de Usuário',
      acessarPortal: 'Acessar Portal do Cliente',
    },
    fileManager: {
      cropModalTitle: 'Cortar imagem',
      crop: 'Cortar',
    },
  },
}
